import React from 'react';
import { Tooltip } from 'react-tooltip';
import { provinces } from '../../data/provinces';
import { MapProps } from '../../interfaces';
import styled from 'styled-components';
import { black, boxShadow1, gray } from 'utils/style/colors';
import { languageDirection } from 'i18n';

const Container = styled.div`
  direction: ${languageDirection()};
  max-width: 20rem;
  border-radius: 1rem;
  background: ${gray};
  padding: 0.75rem 1rem !important;
  display: flex;
  flex-direction: column;
  color: ${black};
  gap: 0.5rem;

  @media screen and (max-width: 600px) {
    width: 80vw;
    gap: 0;
  }
`;

const ContainerHeader = styled.h2`
  @media screen and (max-width: 600px) {
    font-size: 1.2rem !important;
    margin: 0 !important;
    padding: 0;
  }
`;

const ContentContainer = styled.div`
  @media screen and (max-width: 600px) {
    font-size: 0.85rem !important;
  }
`;

const MainContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const IranMapWrapper: React.FC<MapProps> = ({
  textColor,
  mapRef,
  provinceName,
  pathClickedHandle,
  pathMouseOverHandler,
  data,
  width,
  tooltipTitle,
}) => {
  // const badge = `
  //   <div class="react-map-badge">
  //     <div class="react-map-badge-header"><h2>${provinceName}</h2></div>
  //     <div class="react-map-badge-content">
  //       <div>
  //         ${
  //           provinceName &&
  //           data?.[
  //             //@ts-expect-error jsx error
  //             provinces.find(
  //               (item: any) => item.provinceFaName === provinceName
  //             )?.provinceName
  //           ]
  //         }
  //         ${tooltipTitle ? `<span>${tooltipTitle}</span>` : ''}
  //       </div>

  //     </div>
  //   </div>
  // `;

  return (
    <>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1080 1080"
        ref={mapRef}
        style={{
          width: width,
          height: width,
        }}
      >
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="خراسان رضوی"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M649.84,397.97h15.03l6.59-3.69l7.38-7.91l5.27-3.96l7.91-3.69l8.44-1.85h6.86h8.18l7.91,5.54l3.96,2.9
  l1.05,2.11l-3.43,3.43l-4.48,7.12l5.01,9.49l2.9,5.27c0,0,2.37,1.58,7.65,4.75s8.7,3.96,10.55,4.75c1.85,0.79,7.12,0,7.12,0
  s4.48-5.01,4.75-2.37s3.43,7.91,5.8,9.49c2.37,1.58,9.23,8.44,9.23,8.44l2.11-4.75l13.19-0.26l28.48-1.05l6.07,6.07l20.57,2.64
  l5.8,8.97l3.69-2.11l3.96-4.75l11.87-1.05v-5.01l5.27-4.48l7.65-1.85l6.86-1.85l-8.44-13.45l8.44-4.22l3.69-6.33l1.85-3.96
  l2.64-5.01l2.9-12.92l3.16-3.69l-3.16-9.49l5.01-2.64l4.75-16.88l-1.85-9.49l1.85-10.81l-5.8-3.43l3.43-10.55l-2.9-15.56l0.79-7.38
  l0.53-8.18h-45.1l-2.9-5.27l-12.4-16.62l-2.9-3.43h-9.49l-5.27-3.96l-7.12-3.69l-8.97-7.65l-3.16-12.92h-3.69
  c0,0-4.75-3.43-5.8-3.69c-1.05-0.26-8.44-4.22-8.44-4.22l-6.86-3.16h-3.96L775.9,221l-4.75-1.32l-4.48-1.85c0,0-2.11,1.32-2.9,1.58
  c-0.79,0.26-5.8,0.26-5.8,0.26l-2.37,29.54l-4.75,4.22l-2.11,1.58l4.48,4.75c0,0,2.37,3.69,2.11,4.75
  c-0.26,1.05-3.43,4.22-5.01,4.75c-1.58,0.53-4.48,0.26-5.27,2.37s-1.05,3.96-1.05,6.59s-0.26,8.18-0.26,8.18s0.26,0.53-1.32,1.32
  c-1.58,0.79-5.8,0.79-6.59,0.79s-10.55-4.75-10.55-4.75l-12.13-6.86l-9.76-0.53l-8.7-2.9l-5.01-2.37l-12.4,5.27
  c0,0-3.13,1.45-5.53,2.68c-1.29,0.66-2.37,1.26-2.65,1.54c-0.79,0.79-3.16,3.69-3.16,3.69l10.55,0.53c0,0,1.58,5.8,1.85,6.59
  c0.26,0.79-0.26,3.69-0.79,4.75c-0.53,1.05-1.85,3.96-2.9,4.48c-1.05,0.53-2.64,1.32-2.11,2.64c0.53,1.32,5.01,8.7,5.01,8.7
  s-2.9,5.54-2.9,6.59c0,1.05,0.26,8.18,0.26,8.97c0,0.79,1.32,6.07,1.32,6.07l13.71,13.71c0,0,0.53,6.59,0.53,7.65
  c0,1.05,0,4.22,0,6.33c0,2.11-0.53,5.8-1.85,6.86c-1.32,1.05-3.96,0.79-4.75,1.32c-0.79,0.53-4.48,2.11-5.8,2.9
  s-4.48,3.43-4.48,3.43s-3.16,1.85-5.8,2.9c-2.64,1.05-6.33,5.01-6.33,5.01L649.84,397.97z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="خراسان شمالی"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M649.84,189.88l2.9,6.07v7.38v6.07l-4.75,5.54v6.86l-7.38,6.07c0,0-2.9,5.54-2.9,6.86c0,1.32,0,7.38,0,7.38
  h-4.48v6.59c0,0,5.8,0.53,6.07,2.64c0.26,2.11,0.26,6.59-1.05,9.23c-1.32,2.64-2.37,5.54-2.37,6.86c0,1.32,2.11,5.8,2.9,5.8
  s11.08-6.07,11.08-6.07l2.9,8.7l4.48,4.22l8.7,4.22l3.16-3.69l20.57-9.49l13.71,5.27l9.76,0.53l22.68,11.6l6.59-0.79l1.32-1.32
  l0.32-10.02l1-4.75l5.27-2.37l5.01-4.75l-2.11-4.75l-4.48-4.75l6.86-5.8l2.37-29.54l-5.54,2.37l-0.53-8.18l-15.82-1.85l-13.98-7.65
  l-8.97-1.32l-6.86-1.32l-3.96-13.45l-1.85-2.64h-8.7l-7.65,3.16l-12.92-3.16l-6.86,1.32c0,0-5.01-2.9-6.33-1.32
  c-1.32,1.58-8.18,2.11-8.18,2.11V189.88z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="گلستان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M523.77,275.86l1.85,6.07l8.18,2.64l2.11,3.96v3.43l4.1,1.85h11.99l13.71-5.27l2.11-1.32l5.54-1.05l6.07-8.7
  l9.49-3.16l12.13,2.37l8.44-3.43l6.07-7.12v-3.69v-5.54l6.86-5.54v-5.54l7.12-3.43l3.69-0.26h4.48v-7.38l2.9-6.86l7.38-6.07v-6.86
  l4.75-5.54v-13.45h-5.8l-16.35-1.32l-8.7-2.64c0,0-9.23,1.05-11.87,2.37s-12.13,4.75-12.13,4.75l-11.34,5.54l-15.3,12.13l-0.26,5.8
  v5.01c0,0-2.37,5.27-3.43,6.07c-1.05,0.79-8.44,3.48-10.29,3.19s-13.98,2.61-13.98,2.61l-5.54,1.05l-9.49,0.26
  c0,0-1.05,6.59-0.79,7.38c0.26,0.79,3.16,13.71,3.16,13.71l1.58,6.07l-0.26,2.64l-5.01,1.85L523.77,275.86z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="گیلان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M347.59,285.62l-4.22-0.53l-7.91-1.85l-7.12-1.32l-6.07,5.27l-13.98,0.26l-11.6-2.11l-10.02-6.86l-2.11-4.48
  l-3.96-9.23l-12.4-14.51c0,0-4.48-11.6-4.75-12.66s-8.97-16.88-8.97-16.88l-3.96-13.71l1.85-4.22l3.16-6.86l0.53-10.55l-1.58-10.29
  l2.37-2.9h5.01l4.48,2.11l2.64,27.96l3.96,15.82c0,0,6.59,7.12,9.23,8.97c2.64,1.85,8.18,5.54,8.18,5.54h16.88l13.71,1.32
  l11.08,5.01l6.07,1.85l2.11,11.34l7.38,8.18l6.07,3.43l-3.33,7.1l-5.9,9.38L347.59,285.62z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="مازندران"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M352.34,264.78l-1.85,5.8l-6.07,9.23l11.34,12.13l6.59,6.07l3.96,6.07l10.55,4.22l6.33,3.43l7.38,2.64h9.49
  l14.77,8.44l1.85,2.64c0,0,4.22,7.38,5.01,8.18c0.79,0.79,8.97,4.75,8.97,4.75h7.65l4.75-3.16l9.49-3.96l3.96-1.58
  c0,0,8.7,1.32,11.6,2.9c2.9,1.58,9.49,3.69,9.49,3.69l7.12-4.75l14.51-9.76l9.23-1.32l8.97-4.22l7.38-7.91l3.16-7.91l5.8-6.59
  l2.11-1.85v-3.43l-2.11-3.96l-8.18-2.64l-1.85-6.07l-9.76-0.53l-2.9-5.01l-10.29-0.53l-17.67,5.27l-24.53,5.54l-13.45,2.11
  l-9.23,4.75c0,0-7.12,1.58-8.18,1.05c-1.05-0.53-13.45-2.37-13.45-2.37l-9.76-2.37l-24.79-6.33l-21.36-9.23l-4.75-4.48"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="اردبیل"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M250.54,173.79l-7.38-10.29l-3.43-1.58h-2.37l-2.37-6.33l-9.76-1.32l-2.9-3.69v-3.43l5.01-2.64l6.33-2.64
  l2.77-3.43v-3.69l-5.67-3.96l-3.96-5.27l2.9-4.22l6.73-3.16l1.45-4.22l-19.52-19.52l-12.92,5.01l-9.49,5.8l-7.91,5.01l7.91,8.7
  l2.11,7.12l-0.79,11.6l1.05,6.33l1.05,3.43l1.85,1.85l-3.96,2.64l-2.11,3.43l1.58,5.27l-13.71,16.62l7.12,5.54l6.86,1.85h8.97
  l4.75-1.05l0.79,5.54c0,0,2.64,7.91,3.16,8.7c0.53,0.79,5.8,3.96,5.8,3.96l-1.32,4.75l10.29,2.9c0,0-1.85,7.38-2.64,8.18
  c-0.79,0.79-4.48,1.58-4.48,4.75s6.59,16.62,6.59,16.62l6.59,4.48l6.86,2.64l3.69,6.33h6.86h3.96l11.34-2.11l-4.75-12.66
  l-8.97-16.88l-3.96-13.71l5.01-11.08l0.53-10.55l-1.58-10.29L250.54,173.79z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="آذربایجان شرقی"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M188.03,110.23l-7.12,7.65l-5.8,2.9l-4.75,5.54l-3.43,1.58l-5.01,2.11l-8.97,8.44l-5.27,4.75l-1.85,2.64
  l-8.44-1.85l-5.27,0.53l-4.22,1.32l-21.1-1.85l-10.29-0.79l-7.65-3.96l-6.59,2.37l-1.85,4.22v11.6l1.85,7.65l-5.54,4.48
  c0,0-4.22,1.58-4.22,3.82s0,12.26,0,12.26s7.12,16.09,8.7,20.04c1.58,3.96,8.18,25.58,8.18,25.58l15.3,17.67l10.29,2.11l4.75,4.22
  l-1.32,7.65l5.54,1.58l10.55-4.48c0,0,5.54-0.53,8.97-0.79c3.43-0.26,8.18-2.37,8.18-2.37s6.07-0.79,6.86,0.53
  c0.79,1.32,3.16,4.48,3.16,5.8c0,1.32,0.26,3.96,0.26,5.01c0,1.05,1.05,5.54,1.05,5.54h3.16c0,0,6.07-2.37,7.91-3.16
  c1.85-0.79,8.97,0.79,8.97,0.79l7.12-7.91l8.18-3.69l11.34-7.38h6.07h6.07l15.76-8.18l-8.64-5.27l-6.59-16.62l0.29-1.41l1.32-1.61
  l2.87-1.73l2.64-8.18l-10.29-2.9l1.32-4.75l-5.8-3.96l-3.16-8.7l-0.79-5.54l-4.75,1.05H197l-6.86-1.85l-7.12-5.54l13.71-16.62
  l-1.58-5.27l2.11-3.43l3.96-2.64l-1.85-1.85l-2.11-9.76l0.79-11.6l-2.11-7.12l-7.44-9"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="آذربایجان غربی"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M81.48,325.57h12.66l2.37-10.29l2.77-1.98v-5.54h16.62v-9.89l7.91-6.33l6.73,5.14l6.73,0.79l15.43-2.37
  l7.12,2.77l7.12,3.96l10.68,5.14l11.08-8.7l-1.98-6.73l-3.69-13.05l-3-7.69l-5.96-0.22l-7.91,3.16h-3.16l-1.05-5.54l-0.26-5.01
  l-3.16-5.8l-1.65-0.67l-5.21,0.14l-5.46,1.89l-11.68,1.27l-10.55,4.48l-5.54-1.58l1.32-7.65l-4.75-4.22l-10.29-2.11l-15.3-17.67
  l-8.18-25.58l-8.7-20.04V173.4l0.63-1.5l2.49-1.82l6.64-4.98l-1.85-7.65v-11.6l1.85-4.22l6.59-2.37l-8.44-13.71l-5.54-1.05
  l-2.37-5.54l-11.34-9l-2.11-9.99l-7.65-1.05l-6.86-6.59l-8.44,4.75l-1.32,10.55l-3.43,5.8l-7.38,1.05l-7.65-1.05l-3.16,2.64
  c0,0,1.58,5.01,1.85,5.8c0.26,0.79-0.53,4.75,0.26,5.8c0.79,1.05,5.54,3.16,5.54,3.16l-0.53,8.44c0,0,0,5.54,0.79,6.33
  c0.79,0.79,5.54,5.01,5.54,5.01s-1.05,3.69-1.05,5.01c0,1.32,1.05,10.02,1.05,11.08s-0.26,6.86-0.26,7.91s2.64,5.54,3.43,5.54
  c0.79,0,5.54-1.05,5.01,1.32c-0.53,2.37-3.16,8.93-4.48,10.4c-1.32,1.47-4.75,9.91-4.75,9.91s2.37,9.23,3.43,10.02
  c1.05,0.79,6.33,4.48,6.33,4.48s4.75,0.26,5.01,1.85c0.26,1.58,0,1.85,0.53,5.54c0.53,3.69,0.79,6.07,1.58,8.7
  c0.79,2.64,10.29,11.87,10.29,11.87s-2.11,8.97-2.11,10.02s5.8,8.44,6.59,9.23c0.79,0.79,1.85,11.87,1.85,11.87l6.33,8.97
  l4.22,14.77l6.33,0.26l3.69,15.03L81.48,325.57z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="زنجان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M188.69,298.27l5.14-3.16l6.59,3.16l5.01,2.11h9.23c0,0,2.37,5.01,2.37,6.33c0,1.32-0.26,3.69,0,5.01
  c0.26,1.32-3.16,6.86-3.16,6.86s-1.32,3.96-1.32,5.01c0,1.05,4.51,3.16,4.5,3.96c-0.01,0.79,3.41,5.27,3.94,6.33s5.8,2.9,6.86,4.48
  s13.98,5.54,13.98,5.54l8.7,3.16h2.9l1.58-1.32c0,0,1.85-1.32,1.85-2.9c0-1.58,0-5.8,0-5.8v-5.27l8.97-7.38l6.59,5.01l5.27-2.64
  l2.11-3.16l3.69-2.51h2.9c0,0,4.22-4.88,4.22-7.52c0-2.64,0-6.59,0-6.59v-2.64l-3.16-3.69l-5.01-5.54l-9.76-3.16l-3.43-4.75
  l1.58-9.23l2.9-1.85c0,0,2.11,0.79,4.22,0s8.7,2.37,8.7,2.37l-6.07-13.71l-12.4-14.51l-22.15,2.11l-3.69-6.33l-4.81-1.85
  l-15.76,8.18h-12.13l-11.34,7.38l-8.18,3.69l-7.12,7.91l-2.36,1.07L188.69,298.27z"
        />
        <polygon
          data-tooltip-id="iran-map-tooltip"
          data-name="کردستان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          points="95.92,327.35 99.09,330.12 100.08,334.67 106.6,335.66 113.53,333.88 121.84,333.29 132.32,335.66 
  131.13,338.36 120.85,341 116.89,341 115.31,348.91 114.12,355.04 116.49,359.59 120.85,365.13 121.64,369.48 130.34,369.48 
  133.9,372.05 137.46,375.81 139.64,377.4 140.43,384.12 142.41,387.48 144.98,389.26 152.69,392.82 152.69,396.19 172.87,397.18 
  169.7,392.82 172.87,386.49 180.66,384.32 184.74,383.33 184.74,377.59 207.48,378.19 209.07,384.71 210.45,386.69 213.02,382.14 
  226.67,382.14 226.67,370.87 213.81,355.04 209.26,347.07 223.11,345.35 227.86,338.36 221,333.88 217.06,327.55 212.56,323.59 
  213.88,318.58 217.04,311.73 217.04,306.71 214.67,300.38 205.44,300.38 193.84,295.11 188.69,298.27 177.62,306.98 152.69,295.11 
  137.26,297.48 130.54,296.69 123.81,291.55 115.9,297.88 115.9,307.77 99.29,307.77 99.29,313.31 96.52,315.29 94.14,325.57 "
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="کرمانشاه"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M99.09,465.81l4.15-2.57l6.92-6.53l2.37-4.95l-3.96-7.32l10.29-1.38l4.15-5.74l2.57,3.76l14.04,3.76l8.7,9.69
  l6.53,3.96l11.67-1.98c0,0,2.57-3.16,3.16-3.16c0.59,0,6.92,2.57,6.92,2.57s4.55,0.4,5.14,0.2c0.59-0.2,3.36-10.68,3.36-10.68
  l7.91,0.2l-1.19-5.34l4.15-5.74l3.56-7.52l2.57-4.55l10.09,2.77l9.49-7.52v-5.34v-3.16l-9.49-3.76l-2.97-2.77l-0.59-7.32l1.78-8.7
  l-3.94-8.53l-21.77-0.57v5.74l-11.87,3.16l-3.16,6.33l3.16,4.35l-20.18-0.99v-3.36l-10.29-5.34l-1.98-3.36l-0.79-6.73l-9.3-7.91
  h-8.7l0.99,4.75l-1.38,5.14l-9.69-1.98c0,0-3.96,2.18-3.96,3.36c0,1.19-1.38,4.15,0.2,5.74c1.58,1.58,2.37,2.77,1.58,3.16
  s-5.34,2.18-5.34,2.18l-3.1,2.77l-1.85,3.36c0,0-2.37,3.16-2.37,3.76s1.58,4.55,1.58,5.34c0,0.79-3.36,2.37-4.15,2.37
  c-0.79,0-1.98,0.2-2.57,0.79s-1.78,3.96-1.78,3.96s1.19,3.36-0.79,3.46s-2.77-1.48-2.77,0s-0.4,5.84,0,6.63
  c0.4,0.79,6.53,2.77,5.93,4.35s-2.18,5.34-2.37,6.73c-0.2,1.38-2.33,7.32-3.74,8.51c-1.41,1.19-2.59,4.55-2.59,4.55l5.14,4.35
  L99.09,465.81z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="ایلام"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M204.32,571.64l2.18-6.13l6.73-4.95l3.56-15.43l1.58-14.04l6.33-4.95l-1.98-8.31l-12.26-8.7l-6.13-1.98
  l-7.91-8.31l-10.09-5.54l-10.48-5.74l-6.73-4.55l-4.35-4.95l-3.76-5.74l1.98-4.35l4.55,2.18l1.38-4.35h5.14l12.66-3.16l8.51-5.34
  l0.4-3.76v-5.14l-2.57-2.77l-7.91-0.2l-3.36,10.68l-5.14-0.2l-6.92-2.57l-3.16,3.16l-11.67,1.98l-6.53-3.96l-8.7-9.69l-14.04-3.76
  l-2.57-3.76l-4.15,5.74l-10.29,1.38l3.96,7.32l-2.37,4.95l-6.92,6.53l-4.15,2.57l2.57,6.92l6.92-0.79c0,0,1.58,0.59,1.58,2.18
  s-0.4,3.96-0.4,3.96l4.95,2.57c0,0,2.18,1.78,3.36,4.55c1.19,2.77,6.92,8.51,7.12,9.49c0.2,0.99-1.58,3.16-2.97,4.55
  c-1.38,1.38-6.92-0.79-4.35,2.57c2.57,3.36,2.37,1.38,2.57,3.36c0.2,1.98,0.79,5.34,0.79,5.34l15.03,2.18l14.04,9.89
  c0,0,10.29,8.31,11.57,9.3c1.29,0.99,7.22,6.33,7.62,7.12s6.33,3.76,6.92,3.76c0.59,0,6.13,0,6.13,0s6.73,4.15,7.71,6.73
  c0.99,2.57,1.38,3.96,3.16,7.32c1.78,3.36,2.18,3.56,3.96,7.71C199.18,568.67,204.32,571.64,204.32,571.64z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="همدان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M256.87,342.85l4.02-3.43l9.49,7.65l4.75,6.59l3.16,2.18h9.69l3.56,1.78c0,0,0.99,1.19,0,3.16
  s-1.78,2.77-1.78,4.95c0,2.18,4.15,8.11,4.15,8.9s0.59,3.56,0,5.34c-0.59,1.78-7.32,9.69-7.32,9.69s-4.55-2.37-5.74,0.79
  c-1.19,3.16-3.76,7.32-3.76,9.49c0,2.18,0.4,5.93-1.58,8.7s-5.54,3.76-7.32,7.52c-1.78,3.76,2.97,9.1,2.97,9.1l4.35,10.68v5.54
  c0,0-3.36,5.14-5.93,5.34c-2.57,0.2-11.47-2.77-11.47-2.77l-5.14-5.54c0,0-4.55,0-5.74,0.99s-4.95,5.54-4.95,5.54l-6.65-1.98
  l-2.64-1.78l-9.49-7.52l-2.97-2.97l-7.12-2.97l-1.19-2.57l9.49-7.52v-8.51l-9.49-3.76l-2.97-2.77l-0.59-7.32l1.78-8.7l2.57-4.55
  h13.65v-11.27l-12.23-15.06l-5.17-8.75l13.85-1.71l4.75-6.99l13.98,5.54l8.7,3.16l4.48-1.32L256.87,342.85z"
        />
        <polygon
          data-tooltip-id="iran-map-tooltip"
          data-name="قزوین"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          points="291.55,360.78 296.3,359.2 302.23,359.2 303.62,352.87 310.74,352.87 318.65,351.88 324.78,353.07 
  331.7,352.87 336.65,353.66 331.9,348.52 332.3,344.36 339.22,332.1 345.15,326.96 352.87,319.64 356.82,315.29 346.93,309.95 
  346.14,305.4 350.3,305.4 366.32,304.08 362.36,298.01 351.38,286.8 347.59,285.62 328.34,281.92 322.27,287.2 307.77,287.46 
  296.69,285.35 286.67,278.49 282.01,276.64 278.89,276 276.41,276.45 273.75,276.12 270.85,277.97 269.26,287.2 272.69,291.95 
  282.45,295.11 290.63,304.34 290.45,314.62 286.41,321.09 283.51,321.09 279.81,323.59 277.7,326.76 272.43,329.4 265.84,324.38 
  256.87,331.77 256.87,342.85 260.89,339.42 270.38,347.07 275.13,353.66 278.3,355.84 287.99,355.84 291.55,357.62 "
        />
        <polygon
          data-tooltip-id="iran-map-tooltip"
          data-name="البرز"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          points="336.65,353.66 340.87,352.34 343.51,345.88 344.43,343.37 366.32,344.43 376.87,342.45 379.64,335.46 
  384.91,330.19 391.9,330.19 394.8,330.19 399.02,324.91 400.08,316.74 400.08,314.49 390.85,314.49 381.88,311.07 376.74,307.9 
  366.32,304.08 346.14,305.4 346.93,309.95 356.82,315.29 339.22,332.1 332.3,344.36 331.9,348.52 "
        />
        <polygon
          data-tooltip-id="iran-map-tooltip"
          data-name="لرستان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          points="222.71,517.84 225.48,512.3 227.86,509.53 252.58,509.53 259.31,511.51 270.38,513.68 279.48,513.68 
  286.01,516.65 291.55,521.99 294.19,523.97 305.4,518.82 305.4,510.52 305.4,505.57 308.36,503.59 315.88,503.59 318.45,502.21 
  317.26,496.67 313.9,493.11 318.45,490.14 321.81,484.8 321.81,483.22 309.35,483.22 310.54,475.51 303.62,470.36 300.25,462.65 
  287.79,462.65 283.44,467 278.3,464.63 276.91,460.67 266.23,460.67 264.05,458.69 268.21,451.57 268.6,448.01 268.01,446.83 
  258.12,444.05 252.98,438.52 247.24,439.51 242.3,445.04 235.64,443.07 220.54,430.8 213.42,427.84 212.23,425.26 202.14,422.49 
  196.01,434.56 191.86,440.3 193.04,445.64 195.62,448.41 195.22,457.31 186.71,462.65 174.05,465.81 168.91,465.81 167.53,470.16 
  162.98,467.99 161,472.34 169.11,483.02 196.41,498.85 204.32,507.15 210.45,509.13 "
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="خوزستان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M204.32,571.64l7.45,10.68l-5.54,13.98l-3.16,8.44c0,0,0.79,11.6,0,12.4c-0.79,0.79,0,13.71,0,13.71h16.88
  v32.97l6.07,1.32l2.37,3.43l1.58,3.69l7.91,3.43c0,0,2.11,3.96,2.11,4.75s-1.32,3.69,0,5.01c1.32,1.32,5.54,7.65,5.54,7.65h6.07
  l2.37-2.11l15.03-2.64V677l-4.75-3.69l1.05-4.48l3.69-2.11h3.43v-3.96l5.27-1.85c0,0,6.59,0.53,6.86,1.32
  c0.26,0.79,1.32,6.59,1.32,6.59h-8.97c0,0-3.16,6.33-2.37,6.86c0.79,0.53,5.8,1.05,5.8,1.05l4.22,3.96l11.34,1.05l3.96,9.23
  l19.25-13.19h9.76l2.9,1.58l1.85-3.16l3.96,2.37l7.91,4.22l2.9-1.32v-11.6l-4.75-6.86l-1.32-2.11l3.96-4.22l-0.53-3.96l-5.27-7.12
  l-7.38-1.32l-0.53-8.18l-5.8,1.05l-1.85,2.11l-5.8-5.27l-1.05-3.69l3.76-8.18l-4.55-6.86l2.9-2.9l8.44,1.58l4.22-6.07l2.64-8.44
  l3.43-6.07l2.64-3.96l-5.54-9.76l-0.26-4.48l-13.91-11.08l-4.55-8.7v-5.01l-8.44-8.44l-14.77-13.19l0.13-4.81l-8.18-7.32l-6.53-2.97
  h-9.1l-17.8-4.15h-24.73l-5.14,8.31l1.98,8.31l-6.33,4.95l-1.58,14.04l-3.56,15.43l-6.73,4.95L204.32,571.64z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="کهگیلویه و بویراحمد"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M348.38,681.48v11.6l4.75,3.16l3.16,1.32l3.16-3.16l12.4-1.32v-6.07c0,0,0.26-5.54,0-5.54
  s11.34-9.23,11.34-9.23s2.11-2.64,2.11-4.22s-3.43-10.81-3.43-10.81l-1.32-6.86l8.7,5.27c0,0,3.96,4.75,5.27,4.75
  c1.32,0,7.38,0.53,8.18,0.53c0.79,0,0.53,2.9,3.16,1.85s6.33-15.03,6.33-15.03l-23.47-19.52l-1.58-12.13c0,0-6.33,0.53-6.86,0
  c-0.53-0.53-5.27,1.58-5.27,1.58l-6.07-4.22c0,0,0-5.54-1.05-5.54c-1.05,0-5.54,1.58-5.54,1.58l-6.07-5.54c0,0-1.32-2.9-2.9-2.64
  c-1.58,0.26-5.01,1.85-8.7,2.64c-3.69,0.79-8.52-5.73-8.52-5.73l-3.34,9.69l-4.22,6.07l-8.44-1.58l-2.9,2.9l4.55,6.86l-3.76,8.18
  l1.05,3.69l5.8,5.27l1.85-2.11l5.8-1.05l0.53,8.18l7.38,1.32l5.27,7.12l0.53,3.96l-3.96,4.22l6.07,8.97V681.48z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="چهارمحال و بختیاری"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M387.15,616.08V605l-2.9-21.63l3.96-10.02l1.58-1.71v-10.68l-2.77-5.8l-9.1-6.07l-2.11-2.9l-9.23-4.48v-7.65
  l-1.85-7.38v-4.48l-8.18-1.32l-6.59,3.1l-4.48,1.91l-6.33,4.48l-1.85,0.26l-5.01-2.9c0,0-1.85-1.05-2.64-1.05
  c-0.79,0-3.69,0-5.01,0.26c-1.32,0.26-5.8-1.05-5.8-1.05l-13.45-7.05l-11.21,5.14l-0.13,4.81l23.21,21.63v5.01l4.55,8.7l13.91,11.08
  l0.26,4.48l5.54,9.76l-5.36,8.77l4.88,4.74l1.73,0.85l1.91,0.15l8.7-2.64h1.19l1.71,2.64l6.07,5.54l5.54-1.58l0.35,0.25l0.4,1.29
  l0.3,4l6.07,4.22l3.58-1.38l1.69-0.21H387.15z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="مرکزی"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M321.81,483.22v-6.73l8.11-3.26l8.11-4.65l8.11-0.99l5.34-1.78l10.09-4.35h7.71l4.75-7.12V449l-1.58-7.12
  l-4.35-8.7c0,0-10.29-1.98-12.46-1.78c-2.18,0.2-7.91-0.62-8.9-0.01c-0.99,0.61-4.95-2.76-4.95-2.76l-2.57-8.11
  c0,0-4.35-3.16-5.54-2.87c-1.19,0.3-4.15-1.09-4.15-1.09l-2.37-13.25l2.77-7.91l4.15,1.78h3.36l6.99-1.78c0,0,6.26-3.42,6.86-2.8
  c0.59,0.62,5.34,0,5.34,0l1.78-9.66l7.91-5.93l3.16-1.58l2.37-14.64l0.59-2.77l-6.46-3.16l-10.15-2.57c0,0-8.51-0.4-9.1,0
  s-7.32,3.16-7.32,3.16l-7.71-2.57l-8.68-0.14l-4.38-0.85l-7.91,0.99h-7.12l-1.38,6.33h-5.93l-4.75,1.58l-1.59,3.31l-0.19,1.63
  l0.67,2.24l3.49,6.66l0.21,2.17l0.05,2.48l-7.58,10.38l-2.66-0.82l-1.88,0.25l-1.2,1.36l-3.58,8.33l-0.21,5.03l-1.55,4.84l-4,3.6
  l-2.59,2.65l-1.1,2.65l0.29,2.44l3.05,5.28l4.35,10.68v5.54l-2.75,3.39l-3.19,1.96l-1.58,0.01l0.59,1.18l-0.4,3.56l-4.15,7.12
  l2.18,1.98h10.68l1.38,3.96l5.14,2.37l4.35-4.35h12.46l3.36,7.71l6.92,5.14l-1.19,7.71H321.81z"
        />
        <polygon
          data-tooltip-id="iran-map-tooltip"
          data-name="قم"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          points="368.1,433.18 374.03,434.16 374.03,425.46 377.59,422.49 397.37,417.55 412.6,415.57 417.15,413.2 
  424.08,393.81 413,385.7 406.47,382.93 402.71,378.38 392.82,376.41 383.33,374.23 374.03,375.22 368.1,376.11 358.41,382.93 
  356.63,392.6 351.29,392.6 344.43,395.4 338.46,396.92 334.08,397.18 329.92,395.4 327.15,403.31 329.53,416.56 333.68,417.65 
  339.22,420.52 341.79,428.63 346.74,431.38 355.64,431.4 "
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="اصفهان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M412.21,647.73l-1.58-9.49l2.64-12.4l3.43-8.18l1.32-7.38v-10.81l2.64-10.55l12.13-6.59l7.91,4.75
  c0,0,3.16,3.43,4.22,4.48c1.05,1.05,3.69,1.32,3.69,1.32l19.78,0.26l9.23-1.32l10.02-9.49l-7.12-3.96l-2.64-6.59v-40.62l13.45-9.76
  l9.23-1.32l23.21-1.25l3.16-7.71l9.49-1.58l8.7-3.96l1.32-7.38l10.81-2.37l12.66-3.43c0,0,6.33-3.69,8.44-3.69
  c2.11,0,16.88-2.64,16.88-2.64l11.34-8.7l3.16-10.29v-42.2l-140.31,2.11l-8.18-6.07l-7.65-3.36l-9.76-1.38c0,0-9.49,0.13-10.29,1.38
  c-0.79,1.25-3.16,1.52-3.16,1.52l-8.18-2.9l-5.08-2.97l-6.53,2.63l-13.25,1.72l-19.78,4.95l-3.56,2.97v7.58l-5.93,0.13l4.35,8.7
  l1.58,7.12v5.34l-4.75,7.12h-7.71l-10.09,4.35l-5.34,1.78l-8.11,0.99l-16.22,7.91v6.73l-3.36,6.92l-4.55,2.97l3.36,3.56l1.19,5.54
  l-2.57,1.38h-7.52l-2.97,1.98v13.25l13.45,7.05l5.8,1.05l5.01-0.26l7.65,3.96l1.85-0.26l6.33-4.48l11.08-5.01l8.18,1.32v4.48
  l1.85,7.38v7.65l9.23,4.48l2.11,2.9l9.1,6.07l2.77,5.8v10.68l-1.58,1.71l-3.96,10.02l2.9,21.63v11.08l1.58,12.13L412.21,647.73z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="تهران"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M424.08,393.81l5.01-10.75l-0.79-3.82l-4.22-6.07c0,0-1.58-1.05-1.85-2.37c-0.26-1.32,0-6.33,0-7.25
  c0-0.92-0.63-10.15-0.12-11.08c0.51-0.92,5.92,0.26,6.97,1.19c1.05,0.92,18.86,11.21,18.86,11.21l10.42-4.09c0,0,5.27-5.8,7.52-7.65
  s10.42-8.18,10.95-8.84c0.53-0.66,3.3-5.93,3.3-5.93l-2.64-2.37l-10.42-3.96l-10.02-2.24l-13.85,5.01l-5.01,3.43h-6.86l-10.02-4.75
  l-6.46-10.42l-14.11-7.78l-1.71,9.63l-4.22,5.27h-9.89l-5.27,5.27l-2.77,6.99l-10.55,1.98l-21.89-1.05l-3.56,8.97l-1.45,3.1
  l7.32-3.16h9.1l10.15,2.57l6.46,3.16l-2.97,17.41l13.85-1.19l19.38,4.15l3.76,4.55l6.53,2.77L424.08,393.81z"
        />
        <polygon
          data-tooltip-id="iran-map-tooltip"
          data-name="سمنان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          points="418.28,413.86 422.23,416.16 430.41,419.07 433.57,417.55 435.27,416.85 443.86,416.16 449.14,416.91 
  453.62,417.55 461.26,420.91 469.44,426.98 609.75,424.87 632.76,423.29 649.84,397.97 664.47,380.88 673.57,375.81 679.04,371.85 
  683.86,369.48 688.6,368.16 690.45,361.31 689.92,347.33 676.21,333.62 674.89,327.55 674.63,318.58 677.53,311.99 672.46,302.46 
  672.75,301.92 674.1,300.92 675.32,300.03 677.53,296.16 678.32,291.42 676.47,284.82 665.92,284.3 657.22,280.08 652.74,275.86 
  649.84,267.15 638.76,273.22 638.15,272.74 637.07,270.93 635.89,267.75 636.15,265.75 637.38,262.37 638.23,260.56 638.84,258.91 
  639.3,256.31 639.39,252.55 639.19,250.98 637.9,249.85 635.56,249.07 633.22,248.69 633.22,242.1 629.53,242.36 622.41,245.79 
  622.41,251.33 615.55,256.87 615.55,266.1 609.48,273.22 601.04,276.65 588.91,274.27 579.42,277.44 573.35,286.14 567.81,287.2 
  551.99,293.79 540,293.79 535.9,291.95 527.73,301.04 524.82,308.43 517.7,316.08 508.74,320.43 499.24,321.88 477.48,335.99 
  480.12,338.36 476.82,344.3 465.88,353.13 458.36,360.78 447.95,364.87 429.09,353.66 425.92,352.48 422.11,352.47 422.23,370.8 
  424.08,373.18 428.3,379.24 429.09,383.07 424.08,393.81 417.15,413.2 "
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="خراسان جنوبی"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M606.58,477.35l3.16,9.23l10.55,16.62l4.35,7.12l13.45,4.75c0,0,11.6,3.96,11.74,5.54
  c0.13,1.58,10.42,18.22,10.81,19.4c0.4,1.18,5.14,11.07,5.54,14.63c0.4,3.56,3.16,10.29,3.16,10.29h10.29c0,0,9.36-0.4,10.81,0
  c1.45,0.4,9.36,3.56,14.11,5.93c4.75,2.37,23.34,5.14,25.32,6.73c1.98,1.58,11.87,5.54,14.64,7.52s12.26,7.12,15.43,9.1
  c3.16,1.98,12.26,12.26,14.24,13.85s11.08,12.66,11.08,12.66s10.29,7.52,10.29,8.7c0,1.19,5.54,9.49,6.73,11.47
  c1.19,1.98,9.1,10.29,10.29,11.87s4.35,4.35,4.35,4.35l25.32-11.47v-9.89h11.47l7.52-6.73l-1.98-6.33c0,0-0.79-3.56,1.98-3.96
  c2.77-0.4,14.64-3.96,14.64-3.96l9.49-3.16l3.56-9.89v-3.56l-3.16-3.96l-1.98-26.97l1.98-6.66v-9.89l-11.47-45.49l1.19-12.66
  l5.54-9.49l7.91-4.35v-3.96l-10.29-3.56l-7.91-5.93l-1.45-23.74l-11.87,1.05l-3.96,4.75l-3.69,2.11l-6.35-9.04l-20.02-2.57
  l-6.07-6.07l-41.67,1.32l-2.11,4.75l-9.23-8.44l-3.7-4.36l-1.18-2.21l-0.83-2.37l-0.09-0.56l-0.19-0.57l-0.3-0.18l-1.05,0.3
  l-3.44,2.86l-3.01,0.28l-2.96-0.08l-3.53-1.2l-5-2.16l-10.58-6.37l-7.91-14.77l4.48-7.12l3.43-3.43l-1.05-2.11l-11.87-8.44h-15.03
  l-8.44,1.85l-7.91,3.69l-5.27,3.96l-7.38,7.91l-6.59,3.69h-15.03l-17.08,25.32l-23.01,1.58v42.2L606.58,477.35z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="یزد"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M468.38,593.13l4.55,6.2c0,0,1.58,3.96,0.99,4.15c-0.59,0.2-5.54,3.56-5.54,3.56s-0.79,2.37-0.79,3.56
  c0,1.19,10.88,13.65,10.88,13.65l17.41,9.49c0,0,6.92,6.13,7.12,7.12c0.2,0.99,9.3-0.59,10.09,0c0.79,0.59,8.51,2.37,8.51,2.37
  s4.15,1.38,4.55,2.97c0.4,1.58,0.99,15.82,0.99,15.82l-1.19,9.69c0,0-3.96,0.4-0.4,3.36s7.32,6.13,7.91,7.52
  c0.59,1.38,2.18,6.33,2.57,7.52C536.43,691.31,539,701,539,701l5.74,4.35h19.19l-4.95-22.95l1.19-10.68l-8.7-8.51l-3.16-6.13
  l11.27-5.74l-0.99-14.24V619.9l12.07-4.15c0,0,5.34,2.08,6.23,2.37c0.89,0.3,7.12-1.19,7.12-1.19l9.69-2.08l13.45-6.03l9.3-1.38
  l12.16-6.13l1.98-3.56l6.82-9l3.66-5.93l10.19-0.49l8.9-3.66l8.93-3.2l0.26-10.55l-2.34-6.6l-0.83-3.68L660.65,540l-10.81-19.4
  l-25.19-10.29l-14.9-23.74l-3.16-9.23l-11.34,8.7l-16.88,2.64l-8.44,3.69l-23.47,5.8l-1.32,7.38l-8.7,3.96l-9.49,1.58l-3.16,7.71
  l-23.21,1.25l-9.23,1.32l-13.45,9.76v40.62l2.64,6.59l7.12,3.96l-10.02,9.49L468.38,593.13z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="فارس"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M356.3,697.57l2.64,4.75v3.03h12.92l11.6,1.19l5.01,6.33c0,0-0.26,5.54,0,6.33s10.02,3.96,11.08,4.22
  c1.05,0.26,9.76,13.71,9.76,14.51s7.91,13.71,7.91,13.71l5.27,11.87c0,0,3.43,9.49,4.22,11.6c0.79,2.11,6.07,13.71,6.59,16.35
  c0.53,2.64,2.11,8.7,3.43,10.81c1.32,2.11,7.65,7.91,8.7,8.44c1.05,0.53,5.01,3.16,7.38,5.54c2.37,2.37,3.69,4.22,4.48,6.86
  c0.79,2.64,1.58,5.01,2.37,7.38c0.79,2.37,0,4.75,2.37,7.91c2.37,3.16,8.18,8.7,9.76,10.29c1.58,1.58,3.16,4.22,7.91,6.59
  c4.75,2.37,13.98,3.43,20.84,6.86c6.86,3.43,9.76,5.27,12.92,6.86c3.16,1.58,7.18,2.9,7.18,2.9l4.17-1.32l7.65-7.38v-5.27
  l-1.58-5.27c0,0,3.16-2.11,5.27-2.9c2.11-0.79,9.23-3.96,10.81-3.96s19.52,0.79,22.95,1.05c3.43,0.26,20.04,0.26,20.04,0.26
  s8.97-4.22,10.55-5.8c1.58-1.58,13.98-16.88,13.98-16.88s-7.12-15.03-7.91-15.82c-0.79-0.79-2.11-4.22-2.11-6.86s0-15.56,0-17.01
  s2.11-9.89,2.11-9.89l-10.55-15.03l3.96-18.46l-22.68-32.7l-13.38-3.3h-19.19L539,701l-5.54-18.4l-7.91-7.52l-1.37-1.59l0.46-1.36
  l1.31-0.41l1.19-9.69l-0.99-15.82l-4.55-2.97l-8.51-2.37H503l-7.12-7.12l-17.41-9.49l-10.7-13.19l0.61-4.02l5.54-3.56l-0.99-4.15
  l-4.24-5.77l-20.09-0.69l-2.13-0.46l-1.56-0.86l-4.22-4.48l-7.91-4.75l-12.13,6.59l-2.58,10.32l-0.06,11.05l-1.32,7.38l-3.43,8.18
  l-2.64,12.4l1.58,9.49l-2.96,9.27l-1.64,3.68l-1.73,2.07l-1.06,0.22l-0.98-0.43l-1.13-1.64l-8.41-0.57l-2.19-1.63l-2.85-3.08
  l-8.7-5.27l1.32,6.86l3.22,9.66l0.18,1.46l-2.09,3.91l-11.34,9.23v11.6l-12.4,1.32L356.3,697.57z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="کرمان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M785.26,901.57l4.75-3.96l2.37-2.77v-10.29l-7.12-4.35v-8.31v-6.33l-3.96-6.33l5.54-55.78l8.31-3.56l2.37-3.16
  v-7.12l-4.75-6.73l4.75-2.37l9.89-3.56h9.1l3.56-6.73v-22.55v-5.93l-5.93-14.64l-1.19-62.51l3.96-7.52l-14.64-16.22l-6.73-11.47
  l-10.29-8.7l-11.08-12.66l-14.24-13.85l-16.7-9.89l-13.36-6.73l-25.32-6.73l-14.11-5.93h-21.1l-0.26,10.55l-8.93,3.2l-8.9,3.66
  l-10.19,0.49l-10.48,14.93l-1.98,3.56l-12.16,6.13l-9.3,1.38l-13.45,6.03l-16.81,3.26l-6.23-2.37l-12.07,4.15l0.99,31.45
  l-11.27,5.74l3.16,6.13l8.7,8.51l-1.19,10.68l4.95,22.95l13.38,3.3l22.68,32.7l-3.96,18.46l6.33,1.58l10.55,4.48l8.18-6.59
  l16.09-7.12l3.16,1.32l0.26,16.35l-1.32,14.24c0,0-0.26,6.33,0.53,6.86s5.01,5.01,5.01,5.01s3.69,1.32,4.48,2.11
  s7.65,3.16,7.65,3.16l8.18,0.26l7.91-5.8v-1.32l12.66-2.11l2.37,6.33c0,0-0.53,7.12,0,8.7s7.38,5.54,7.38,5.54l6.86,1.05
  c0,0,8.97,0,8.97,1.05s0.79,7.38,0.79,7.38l-9.49,10.55l5.01,3.96c0,0,0.79,5.8,0.79,7.65s0,7.12,0,7.12l2.9,6.07
  c0,0,6.59,2.37,7.65,5.54c1.05,3.16,11.34,10.81,11.34,10.81l9.76,1.58c0,0,5.93,6.33,7.71,7.65s15.49,3.43,15.49,3.43l5.01,6.07
  L785.26,901.57z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="سیستان و بلوچستان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M785.26,901.57l5.14,18.2l4.75,13.05l-4.95,4.75l4.95,3.96l8.31,6.73v7.91v8.31v3.56v3.56l11.08-3.16
  l5.54,3.16l2.37,2.37h15.03l13.45,2.37h11.47l2.77,3.56l5.14-7.91l8.7,7.91c0,0,2.77,3.96,3.96,3.96s36.79,6.73,36.79,6.73
  l5.14-2.37l3.56-4.35l1.98-29.27l3.16-5.93l2.37-8.7v-8.7v-4.75l2.37-4.75l11.47,0.4l4.75-10.29l6.33,1.98c0,0-3.16-0.79,0-3.96
  c3.16-3.16,6.73-6.33,6.73-6.33l18.2-1.98l24.92-2.77v-5.54v-5.54l3.56-9.1v-3.96l2.77-2.77v-7.91c0,0-5.14-4.35-6.33-4.35
  s-11.87,0-11.87,0h-4.75c0,0-1.58-0.4-3.16,0c-1.58,0.4-3.96-9.49-3.96-9.49v-33.23l-0.79-7.12l0.4-9.89l0.4-3.16
  c0,0-8.7-0.79-10.68,0s-8.7-5.14-8.7-5.14l-4.35-3.16l-11.47-3.96c0,0-8.31-5.54-9.89-5.54c-1.58,0-11.87-13.05-11.87-13.05
  l-8.7-13.45l-5.54-11.47l-5.14-13.85l-21.76-24.13v-4.35l49.45-59.34l0.79-9.49v-4.75l-3.56-11.08l-1.98-5.14l-10.29-3.16h-7.91
  l-26.51-7.52l-3.56,13.45l-24.13,7.12l-1.34,0.64l-0.66,1.35l0.02,1.96l1.98,6.33l-7.52,6.73h-11.47v9.89l-25.32,11.47l-3.96,7.52
  l1.19,62.51l5.93,14.64v28.48l-3.56,6.73h-9.1l-9.89,3.56l-4.75,2.37l4.75,6.73v7.12l-2.37,3.16l-8.31,3.56l-5.54,55.78l3.96,6.33
  v14.64l7.12,4.35v10.29l-2.37,2.77L785.26,901.57z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="بوشهر"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M345.48,682.8l-11.87-6.59l-1.85,3.16l-3.03,1.25l3.36,4.55l-0.4,10.68l22.55,26.7l3.96,1.98v9.69
  c0,0-0.2,4.55,0,5.14c0.2,0.59,0,4.35,0,4.35h4.35h5.74c0,0,2.18,0.4,2.77,2.18c0.59,1.78,1.38,4.95,1.38,4.95s1.19,1.58,0,2.37
  c-1.19,0.79-5.74,2.18-5.74,2.18s0.2,3.76,0.4,4.55c0.2,0.79,1.58,2.37,2.77,2.97c1.19,0.59,7.12,0.99,7.71,1.19
  c0.59,0.2,2.18,2.57,2.18,4.15s0,7.71,0,7.71l0.99,6.73c0,0,1.38,3.96,2.18,4.75c0.79,0.79,2.97,4.55,4.15,5.34
  c1.19,0.79,2.77,3.76,2.97,4.35c0.2,0.59-0.4,5.34,0,6.33c0.4,0.99,1.98,2.97,2.77,4.35c0.79,1.38,3.76,3.96,4.75,5.34
  c0.99,1.38,4.75,6.92,4.75,6.92s2.18,2.37,4.15,3.36s18.79,1.19,20.37,1.19c1.58,0-0.2-0.4,7.91,4.75
  c8.11,5.14,8.11,5.54,10.09,6.53s-0.59-2.37,5.74,1.58c6.33,3.96,8.7,6.73,8.7,6.73l2.18,5.34c0,0-3.96,2.57-3.16,3.16
  c0.79,0.59,5.93,4.35,5.93,4.35l4.35,2.97l9.36-5.74l-6.13-5.6l-9.76-10.29l-2.65-8.74l-2.1-6.55l-2.06-4.1l-2.42-2.75l-7.38-5.54
  l-8.7-8.44l-3.43-10.81l-10.81-27.96l-5.27-11.87l-7.91-13.71l-9.76-14.51l-11.08-4.22v-6.33l-5.01-6.33l-11.6-1.19h-12.92v-3.03
  l-2.64-5.87l-7.91-3.36v-9.89L345.48,682.8z"
        />
        <path
          data-tooltip-id="iran-map-tooltip"
          data-name="هرمزگان"
          onMouseOver={(e: any) => pathMouseOverHandler(e)}
          onClick={(e: any) => pathClickedHandle(e.target.dataset.name)}
          d="M468.58,860.03l7.98,5.54l8.84,6.33l13.32,3.69h4.48l3.16,5.27c0,0-1.32,4.48,0,4.75
  c1.32,0.26,9.49,6.86,9.49,6.86h4.8l12.08-2.11l4.48,2.11l5.54,1.85h4.48l3.69,3.69c0,0,4.22,1.32,5.27,2.11
  c1.05,0.79,5.54,2.11,6.07,2.9s3.69,3.16,3.69,3.16s8.18-1.85,8.97-1.85s3.69-1.58,4.75-2.77c1.05-1.19,10.55-8.57,10.55-8.57
  l7.38-3.43l7.38,0.53l3.16-3.16c0,0,0.79-0.79,1.85-2.37c1.05-1.58,6.59-8.18,6.59-8.18l5.01-1.05c0,0,7.38-1.05,8.18-1.05
  s4.75-0.79,6.86-2.37c2.11-1.58,6.59-4.75,6.59-4.75l5.8-4.22l11.6,2.11l17.67,1.85l3.69,9.49l3.69,0.79l6.07,13.19v9.23v10.29
  l1.32,6.59c0,0,2.9,4.75,4.48,7.65c1.58,2.9,0,6.33,0,6.33s1.14,3.16,0.7,3.96c-0.44,0.79,4.04,8.7,4.04,8.7s-0.26,4.48,0,5.27
  c0.26,0.79,1.85,3.69,1.85,3.69h20.57l2.37,1.85l2.11,5.27l4.48-3.96c0,0,2.37-1.05,3.16,1.58c0.79,2.64,2.9,5.54,2.9,5.54h8.97
  h11.34l10.55,2.11h10.68l6.46,5.01l2.9,1.85h3.69l6.33,1.32l2.77-1.05v-23.34l-13.25-10.68l4.95-4.75l-9.89-31.25l-17.01-8.84
  l-5.01-6.07l-15.49-3.43l-7.71-7.65l-9.76-1.58l-7.23-5.95l-4.11-4.87l-1.97-2.48l-5.68-3.06l-2.9-6.07l-0.79-14.77l-5.01-3.96
  l9.49-10.55l-0.79-7.38l-8.97-1.05l-6.86-1.05l-7.38-5.54v-8.7l-2.37-6.33l-12.66,2.11v1.32l-7.91,5.8l-8.18-0.26l-7.65-3.16
  l-4.48-2.11l-5.01-5.01l0.79-21.1l-0.26-16.35l-3.16-1.32l-16.09,7.12l-8.18,6.59l-10.55-4.48l-6.33-1.58l10.55,15.03l-2.11,9.89
  v17.01l2.11,6.86l7.91,15.82l-15.22,17.8l-9.31,4.88l-42.99-1.32l-6.98,2.4l-9.11,4.46l0.98,3.27l0.6,7.28l-7.65,7.38l-4.17,1.32
  l-20.1-9.76l-10.31-3.59l-12.31-4.26L468.58,860.03z"
        />
        <path
          className="react-map-water"
          d="M245.53,693.09v3.03l-7.12-1.52l-7.52-4.81l-6.99-1.71c0,0-3.96,1.58-4.48,2.64
  c-0.53,1.05-1.45,5.54-1.05,6.86c0.4,1.32,5.41,10.68,6.46,11.08c1.05,0.4,1.45,4.22,1.98,4.88c0.53,0.66,0.79,1.85,0.79,1.85
  l-0.79,1.32c0,0-2.24-0.92-3.3-0.92s-1.19-2.37-3.96-0.53c-2.77,1.85-7.65,12-9.36,13.05s2.77,4.62,3.16,4.62
  c0.4,0,5.8-4.75,7.91-3.16s5.14,4.88,5.14,4.88l1.26,15.96l5.73,7.91l2.64,5.8c0,0,3.96,7.65,4.48,8.7
  c0.53,1.05,4.75,13.71,5.01,14.51c0.26,0.79,0.79,6.86,1.58,8.97c0.79,2.11,7.65,14.77,7.65,14.77s3.69,1.05,4.48,2.64
  c0.79,1.58,5.54,11.34,5.54,11.34s-1.85,0.53-2.11,2.9c-0.26,2.37,1.58,3.69,2.11,5.54c0.53,1.85,0.79,2.9,1.32,4.48
  c0.53,1.58,9.49,5.01,11.87,5.54s9.76,1.58,9.76,1.58s-6.59,2.37-6.07,5.01c0.53,2.64,6.07,5.54,6.07,6.86
  c0,1.32,4.48,9.23,5.01,10.02c0.53,0.79,7.65,0,7.65,0s0-2.11,1.05-1.32c1.05,0.79,6.86,12.13,6.86,12.13l10.02,6.33
  c0,0,6.33,3.96,7.12,4.75c0.79,0.79,3.3,4.48,3.3,4.48h-5.14l2.11,10.81c0,0,4.22,5.54,6.07,7.38s1.85,4.75,1.85,6.33
  c0,1.58-0.53,9.23-1.32,9.49c-0.79,0.26-3.56,4.22-3.56,4.22l-5.14-6.33c0,0-0.53,7.38,0.53,8.7c1.05,1.32,4.62,4.75,4.62,4.75
  l1.19,7.12l5.54,8.97l1.58,3.96l4.75,8.7l5.01,1.58l3.96,11.6c0,0,0.79,5.8,1.05,7.12c0.26,1.32,1.85,6.59,1.85,6.59l5.01,6.33
  c0,0,2.64,6.33,3.43,8.44c0.79,2.11,1.58,5.01,1.58,5.01l2.9-1.32l1.32-9.23l-5.01-10.55l0.26-15.03l2.37-13.71l4.48-2.9l3.96-15.82
  l2.64-9.49l12.66-9.23l6.33,5.01l1.58,5.8l6.16,3.16c0,0,2.01,2.64,2.54,4.75s-1.92,8.97-2.54,11.34c-0.62,2.37-2.47,7.12-2.47,8.18
  s2.47,14.51,2.47,14.51s2.16,0.26,2.61,1.85c0.45,1.58-0.72,8.44,0,9.76c0.72,1.32-0.5,5.8,0.11,7.91c0.61,2.11-1.5,3.96-3.87,7.91
  c-2.37,3.96-4.22,5.27-3.43,7.12c0.79,1.85,0.79,3.96,0.79,3.96h167.21l2.9-7.65l6.59-5.27l21.36-20.57l8.7-15.03l3.16-3.96
  l6.33-2.37l8.44-7.12l6.07-7.65l5.7-7.91l6.16-14.24l1.85-4.22c0,0,5.27,1.58,6.07,1.58c0.79,0,7.12-5.27,7.12-5.27
  s0.79,5.27,0,6.07c-0.79,0.79-2.9,6.33-2.37,7.65s1.32,10.29,1.32,11.34c0,1.05-4.48,10.81-4.48,10.81l-2.37,5.01
  c0,0,5.27,2.11,5.27,3.16c0,1.05,0.26,16.35,0.26,16.35l-1.05,11.6l3.78,16.35l5.45,10.29l379.78,0.53v-42.46h-10.55l-3.69,0.79
  l-3.43,5.01l-1.58,5.8l-7.91-1.58l-13.45-2.37l-6.07,0.79L989,983.2h-7.38l-7.12,0.26c0,0-7.12,1.32-7.91,2.11s-1.58,5.01-1.58,5.01
  l-3.69-3.96l-3.43-2.37l-7.65,0.53l1.32,5.8h-7.91l-5.8,5.8l-4.22-0.79l1.85-10.02l-6.99-1.71l-3.56,4.35l-5.14,2.37l-36.79-6.73
  l-3.96-3.96l-8.7-7.91l-5.14,7.91l-3.82-3.56h-10.42l-13.45-2.37h-15.03l-2.37-2.37l-5.54-3.16l-11.08,3.16l-2.77,1.05l-10.02-1.32
  l-9.36-6.86h-10.68l-11.6-2.11h-19.25l-2.9-5.54l-3.16-1.58l-4.48,3.96l-2.11-5.27l-2.37-1.85h-20.57l-1.85-3.69v-5.27l-4.04-8.7
  l-0.7-3.96v-6.33l-4.48-7.65l-1.32-6.59v-19.52l-6.07-13.19l-3.69-0.79l-3.69-9.49l-29.27-3.96l-5.8,4.22l-6.59,4.75l-6.86,2.37
  l-13.19,2.11l-8.44,10.55L605,890.1l-7.38-0.53l-7.38,3.43l-15.3,11.34l-8.97,1.85l-3.69-3.16l-12.4-6.07l-2.64-2.64h-4.48
  l-10.02-3.96l-16.88,2.11l-9.49-6.86v-4.75l-3.16-5.27l-6.13-0.46l-11.67-3.24l-16.81-11.87l-10.29-7.32l3.16-3.16l-2.18-5.34
  l-6.29-5.15l-4.61-2.85l-1.86-0.7l-1.68,0.39l-18-11.27l-20.37-1.19l-4.15-3.36l-4.75-6.92l-7.52-9.69v-6.33l-2.97-4.35l-4.92-6.61
  l-1.71-5.55l-0.69-6.57l-0.36-7.35l-1.82-2.61l-7.71-1.19l-2.77-2.97l-0.4-4.55l5.74-2.18v-2.37l-1.38-4.95l-2.77-2.18h-10.09
  v-19.19l-3.96-1.98l-22.55-26.7l0.4-10.68l-3.36-4.55l0.13-2.84h-9.76l-19.25,13.19l-3.96-9.23l-11.34-1.05l-4.22-3.96l-5.8-1.05
  l2.37-6.86h8.97l-1.32-6.59l-6.86-1.32l-5.27,1.85v3.96H269l-3.69,2.11l-1.05,4.48L269,677v11.34l-15.03,2.64l-2.37,2.11H245.53z"
        />
        <path
          className="react-map-water"
          d="M528.25,240.78l-4.48-17.41V202.8l-1.32-16.62l1.32-18.2l4.48-16.62c0,0-0.79-2.9,0-3.96
  s-10.02-11.08-10.02-11.08l-5.27-6.86l-2.9-8.44c0,0-14.77-3.16-15.56-3.16s-6.33-1.58-6.33,0s0,7.65,0,7.65l-5.27-12.4l6.86-5.54
  h13.45l8.97,1.05l2.9-2.64c0,0-0.26-3.16-1.85-3.69c-1.58-0.53-10.81-6.33-10.81-6.33l3.19-7.91l1.83-7.91l-5.8-2.11l-4.48,3.69
  l-6.59-1.85h-16.88l5.01,10.02L463.9,73.57l2.9-3.43l-170.37-2.11v9.23v3.69c0,0-6.59,6.33-5.8,7.91c0.79,1.58,2.11,3.96,1.58,5.54
  c-0.53,1.58-4.48,7.38-4.48,7.38s0.53,4.22,0,5.54c-0.53,1.32,2.9,12.4,2.9,12.4l-2.96-0.79c0,0-4.96,14.77-5.22,16.62
  c-0.26,1.85-6.59,3.96-6.59,3.96v-7.12l-7.65-4.48l-1.85,13.71v8.44v24.26l2.64,27.96l3.96,15.82l9.23,8.97l8.18,5.54h16.88
  l11.8,1.13l12.99,5.19l6.07,1.85l2.11,11.34l7.38,8.18l6.07,3.43l4.75,4.48l21.36,9.23l17.56,4.48l16.99,4.22l15.72,2.37l5.91-1.05
  l9.23-4.75l21.14-3.85l34.51-9.08l10.29,0.53l2.9,5.01l9.76,0.53l3.16-3.43l5.01-1.85l-4.48-22.42L528.25,240.78z"
        />
        <g style={{ fill: textColor }}>
          <path
            d="M555.25,260.79c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C551.51,259.73,552.76,260.8,555.25,260.79z M554,252.48l1.25-1.25l1.26,1.26l-1.25,1.25
      L554,252.48z"
          />
          <path
            d="M566.84,257.63c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V257.63z"
          />
          <path
            d="M573,257.63c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.04-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.98c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V257.63
      z M566.52,250.12l1.25-1.25l1.26,1.26l-1.25,1.25L566.52,250.12z M569.31,250.12l1.25-1.25l1.26,1.26l-1.25,1.25L569.31,250.12z"
          />
          <path
            d="M581.48,255.44c0.06,0.91,0.52,1.36,1.37,1.36c0.86,0,1.29-0.57,1.28-1.71c0-0.45-0.01-0.82-0.04-1.12l-0.04-0.52
      l1.42-0.17l0.14,1.63c0.11,1.27,0.64,1.9,1.59,1.9h0.15c0.12,0,0.17,0.22,0.17,0.66v0.16c0,0.5-0.06,0.76-0.17,0.76h-0.14
      c-1.15,0-1.86-0.41-2.14-1.23c-0.41,0.82-1.13,1.23-2.17,1.23s-1.74-0.4-2.13-1.21c-0.58,0.81-1.4,1.21-2.45,1.21
      c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66
      h0.5c1.18,0,1.86-0.42,2.04-1.26c0.03-0.14,0.04-0.34,0.04-0.6c0-0.25-0.01-0.51-0.03-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.59,1.37,1.58,1.37c0.92,0,1.47-0.42,1.63-1.26c0.03-0.14,0.04-0.34,0.04-0.6c0-0.26-0.01-0.52-0.04-0.8l-0.05-0.52
      l1.42-0.17L581.48,255.44z"
          />
          <path
            d="M587.64,258.39h-0.43c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.45c1.52,0,2.29-0.59,2.29-1.78l0.04-9
      h1.49v9c0,1.19,0.62,1.78,1.86,1.78h0.15c0.14,0,0.21,0.22,0.21,0.66v0.16c0,0.5-0.07,0.76-0.21,0.76h-0.13
      c-1.23,0-2.14-0.41-2.72-1.22C590.08,257.98,589.08,258.39,587.64,258.39z"
          />
          <path
            d="M598.6,252.72c0.75,0.81,1.11,1.7,1.09,2.66c-0.03,2-1.73,3.01-5.09,3.01h-1.23c-0.33,0-0.5-0.25-0.5-0.76v-0.16
      c0-0.44,0.17-0.66,0.5-0.66h1.22c2.37,0,3.55-0.55,3.56-1.64c0-0.56-0.3-1.12-0.89-1.68c-0.88-0.82-1.66-1.5-2.35-2.04
      c-0.65-0.51-0.98-1.05-0.98-1.61c0-0.74,0.4-1.27,1.2-1.57l5.96-2.26v1.56l-5.77,2.15C596.81,250.97,597.9,251.97,598.6,252.72z
       M601.03,244.76l-6.72,2.59v-1.1l6.72-2.59V244.76z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M657.98,240.44c0.12,0,0.17,0.21,0.17,0.64v0.16c0,0.49-0.06,0.73-0.17,0.73h-1.18h-0.21c0.31,0.24,0.47,0.56,0.47,0.94
      c0,0.85-0.5,1.59-1.5,2.24c-1.15,0.75-2.51,1.12-4.08,1.12c-3.56,0-5.33-1.43-5.33-4.3c0-1.18,0.28-2.38,0.84-3.59l1.32,0.54
      c-0.47,1.19-0.71,2.17-0.71,2.95c0,1.96,1.29,2.94,3.87,2.94c0.97,0,1.85-0.18,2.62-0.53c0.64-0.29,1.09-0.64,1.36-1.04
      c0.13-0.19,0.19-0.38,0.19-0.56c0-0.48-0.37-0.71-1.09-0.71h-1.27c-0.32-0.03-0.54-0.29-0.66-0.78c-0.06-0.23-0.08-0.4-0.08-0.51
      c0-0.13,0.03-0.2,0.09-0.22H657.98z"
          />
          <path
            d="M657.88,241.97c-0.32,0-0.48-0.24-0.48-0.73v-0.16c0-0.43,0.16-0.64,0.48-0.64h0.4c1.48,0,2.21-0.69,2.21-2.08v-8.32h1.44
      v8.37c0,2.37-1.23,3.56-3.7,3.56H657.88z"
          />
          <path
            d="M668.09,241.24c0,0.49-0.05,0.73-0.17,0.73h-0.17c-2.15,0-3.22-1.2-3.22-3.6v-8.33h1.44v8.31c0,1.39,0.6,2.09,1.8,2.09
      h0.15c0.11,0,0.17,0.21,0.17,0.64V241.24z"
          />
          <path
            d="M673.2,242.15c-1.02,0-1.99-0.46-2.9-1.37c-0.68,0.79-1.46,1.19-2.32,1.19h-0.17c-0.32,0-0.47-0.24-0.47-0.73v-0.16
      c0-0.43,0.16-0.64,0.47-0.64h0.13c0.51,0,0.95-0.26,1.34-0.78c0.2-0.28,0.41-0.66,0.62-1.14c0.72-1.6,1.67-2.4,2.85-2.41
      c0.9,0,1.6,0.33,2.12,0.99c0.37,0.48,0.63,1.07,0.78,1.78c0.22,1.04,0.66,1.56,1.31,1.56h0.12c0.11,0,0.17,0.21,0.17,0.64v0.16
      c0,0.49-0.06,0.73-0.17,0.73h-0.13c-0.64,0-1.16-0.31-1.56-0.93C674.9,241.78,674.18,242.15,673.2,242.15z M673.11,240.66
      c0.8,0.01,1.2-0.38,1.18-1.15c-0.01-0.32-0.07-0.62-0.19-0.91c-0.26-0.6-0.71-0.9-1.34-0.9c-0.75-0.01-1.32,0.56-1.73,1.72
      C671.73,240.24,672.43,240.66,673.11,240.66z"
          />
          <path
            d="M683.94,239.22c0.03-0.16,0.05-0.35,0.05-0.58c0-0.25-0.01-0.51-0.03-0.77l-0.05-0.5l1.37-0.17l0.13,1.92
      c0.06,0.87,0.5,1.31,1.3,1.31c0.82,0,1.24-0.59,1.24-1.78c0-0.57-0.12-1.27-0.37-2.12l1.42-0.38c0.28,0.87,0.41,1.69,0.41,2.44
      c0,0.02,0,0.03,0,0.05c-0.01,1.26-0.34,2.18-1.01,2.76c-0.41,0.36-0.96,0.55-1.65,0.55c-1.02,0-1.7-0.39-2.02-1.16
      c-0.56,0.78-1.35,1.17-2.36,1.17c-1.18-0.01-1.94-0.4-2.27-1.17c-0.44,0.78-1.34,1.17-2.68,1.17h-0.46c-0.32,0-0.48-0.24-0.48-0.73
      v-0.16c0-0.43,0.16-0.64,0.48-0.64h0.48c1.13,0,1.79-0.41,1.96-1.22c0.03-0.16,0.05-0.35,0.05-0.58c0-0.24-0.01-0.5-0.03-0.77
      l-0.05-0.5l1.37-0.17l0.13,1.92c0.06,0.88,0.57,1.32,1.53,1.32C683.26,240.44,683.78,240.03,683.94,239.22z M681.91,234.16
      l1.17-1.18l1.19,1.19l-1.18,1.18L681.91,234.16z M683.23,231.93l1.18-1.18l1.19,1.19l-1.18,1.18L683.23,231.93z M684.6,234.16
      l1.18-1.18l1.19,1.19l-1.18,1.18L684.6,234.16z"
          />
          <path
            d="M700.85,244.29c2.63-0.01,3.95-1.24,3.94-3.67c0-1.06-0.25-2.1-0.75-3.13l1.44-0.51c0.54,1.35,0.81,2.56,0.81,3.64
      c0,1.03-0.19,1.92-0.56,2.66c-0.82,1.65-2.48,2.47-4.95,2.46c-3.33,0-5-1.53-5.01-4.59c0-1.18,0.28-2.44,0.83-3.78l1.32,0.54
      c-0.46,1.17-0.69,2.26-0.69,3.26C697.23,243.26,698.44,244.29,700.85,244.29z M699.64,236.27l1.21-1.21l1.22,1.22l-1.21,1.21
      L699.64,236.27z"
          />
          <path
            d="M712.03,241.24c0,0.49-0.05,0.73-0.17,0.73h-0.17c-2.15,0-3.22-1.2-3.22-3.6v-8.33h1.44v8.31c0,1.39,0.6,2.09,1.8,2.09
      h0.15c0.11,0,0.17,0.21,0.17,0.64V241.24z"
          />
          <path
            d="M718.75,239.22c0.03-0.16,0.05-0.35,0.05-0.58c0-0.25-0.01-0.51-0.03-0.77l-0.05-0.5l1.37-0.17l0.13,1.92
      c0.06,0.87,0.49,1.31,1.3,1.31c0.82,0,1.24-0.59,1.24-1.78c0-0.57-0.12-1.27-0.37-2.12l1.42-0.38c0.28,0.87,0.41,1.69,0.41,2.44
      c0,0.02,0,0.03,0,0.05c0,1.26-0.34,2.18-1.01,2.76c-0.42,0.36-0.96,0.55-1.65,0.55c-1.02,0-1.7-0.39-2.02-1.16
      c-0.56,0.78-1.35,1.17-2.37,1.17c-1.18-0.01-1.94-0.4-2.27-1.17c-0.44,0.78-1.34,1.17-2.68,1.17h-0.46c-0.32,0-0.48-0.24-0.48-0.73
      v-0.16c0-0.43,0.16-0.64,0.48-0.64h0.48c1.13,0,1.79-0.41,1.96-1.22c0.03-0.16,0.05-0.35,0.05-0.58c0-0.24-0.01-0.5-0.03-0.77
      l-0.05-0.5l1.37-0.17l0.13,1.92c0.06,0.88,0.57,1.32,1.53,1.32C718.07,240.44,718.59,240.03,718.75,239.22z"
          />
          <path d="M726.4,230.04h1.43v11.92h-1.43V230.04z" />
          <path
            d="M734.46,237.55l0.47,1.6c0.25,0.86,0.77,1.29,1.58,1.29h0.23c0.11,0,0.17,0.2,0.17,0.6v0.2c0,0.49-0.06,0.73-0.17,0.73
      h-0.14c-0.79,0-1.29-0.15-1.51-0.44c-0.32,2.63-2.23,4.13-5.73,4.5l-0.35-1.41c3.14-0.32,4.7-1.62,4.7-3.92
      c0-0.83-0.22-1.71-0.66-2.65L734.46,237.55z"
          />
          <path
            d="M736.6,241.97c-0.32,0-0.48-0.24-0.48-0.73v-0.16c0-0.43,0.16-0.64,0.48-0.64h0.5c1.83,0,4.08-0.69,6.77-2.08l0.61-0.31
      c-0.14-0.04-0.74-0.27-1.79-0.7c-1.08-0.44-1.82-0.66-2.21-0.66c-0.62,0-1.14,0.26-1.54,0.78l-0.23,0.3l-1.28-0.63l0.13-0.23
      c0.7-1.15,1.67-1.72,2.93-1.73c0.7,0,1.54,0.24,2.52,0.71c1.73,0.84,3.06,1.28,4.01,1.32l-0.02,1.44
      c-0.64,0.06-1.81,0.53-3.52,1.44c-2.37,1.25-4.53,1.88-6.48,1.88H736.6z M739.93,232.13l1.21-1.21l1.22,1.22l-1.21,1.21
      L739.93,232.13z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M703.13,515.4c0.12,0,0.18,0.22,0.18,0.66v0.16c0,0.5-0.06,0.76-0.18,0.76h-1.22h-0.21c0.33,0.25,0.49,0.58,0.49,0.97
      c0,0.88-0.52,1.65-1.56,2.32c-1.19,0.77-2.6,1.16-4.23,1.16c-3.68,0-5.53-1.48-5.53-4.45c0-1.22,0.29-2.46,0.87-3.72l1.37,0.56
      c-0.49,1.23-0.73,2.25-0.73,3.06c0,2.03,1.34,3.04,4.01,3.04c1.01,0,1.91-0.18,2.72-0.55c0.66-0.3,1.13-0.66,1.41-1.08
      c0.13-0.2,0.2-0.39,0.2-0.58c0-0.49-0.38-0.74-1.13-0.74h-1.32c-0.33-0.03-0.56-0.3-0.68-0.81c-0.06-0.24-0.09-0.42-0.09-0.53
      c0-0.13,0.03-0.21,0.09-0.23H703.13z"
          />
          <path
            d="M703.67,516.98h-0.65c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.65c0.92,0,1.54-0.09,1.87-0.27
      c0.49-0.29,0.73-0.89,0.73-1.8c0-0.68-0.11-1.44-0.32-2.28l1.4-0.35c0.28,0.89,0.42,1.76,0.42,2.6c0,1.4-0.4,2.41-1.2,3.02
      C705.98,516.76,705.02,516.98,703.67,516.98z M704.13,519.7l1.25-1.25l1.26,1.26l-1.25,1.25L704.13,519.7z"
          />
          <path
            d="M715.49,515.41h0.88c0.12,0,0.17,0.24,0.17,0.73v0.09c0,0.5-0.06,0.76-0.17,0.76l-0.96-0.01c-0.43,2.47-2.36,3.88-5.8,4.22
      l-0.36-1.47c2.71-0.3,4.3-1.21,4.75-2.74h-1.25c-2.1,0-3.14-0.85-3.14-2.56c0-0.69,0.15-1.35,0.45-1.97
      c0.54-1.13,1.35-1.69,2.44-1.69C714.22,510.76,715.22,512.31,715.49,515.41z M714.05,515.4c-0.13-2-0.69-3.01-1.67-3.02
      c-0.54-0.01-0.93,0.34-1.18,1.03c-0.1,0.3-0.15,0.6-0.15,0.88c0,0.74,0.54,1.11,1.61,1.11H714.05z"
          />
          <path
            d="M722.71,516.22c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.03-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.98c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.11,0,0.17,0.25,0.17,0.74V516.22
      z M718.23,508.73l1.25-1.25l1.26,1.26l-1.25,1.25L718.23,508.73z"
          />
          <path
            d="M722.4,516.98c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.52c1.89,0,4.23-0.72,7.01-2.16l0.64-0.33
      c-0.15-0.04-0.77-0.28-1.86-0.72c-1.12-0.45-1.89-0.68-2.29-0.68c-0.65,0-1.18,0.27-1.6,0.81l-0.24,0.31l-1.32-0.65l0.14-0.24
      c0.72-1.19,1.73-1.78,3.03-1.79c0.73,0,1.6,0.25,2.61,0.74c1.79,0.87,3.17,1.33,4.15,1.37l-0.02,1.5
      c-0.66,0.06-1.87,0.55-3.64,1.49c-2.46,1.29-4.69,1.94-6.71,1.94H722.4z M727.29,519.7l1.25-1.25l1.26,1.26l-1.25,1.25
      L727.29,519.7z"
          />
          <path
            d="M744.92,519.38c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C741.17,518.32,742.42,519.39,744.92,519.38z M743.66,511.07l1.25-1.25l1.26,1.26l-1.25,1.25
      L743.66,511.07z"
          />
          <path
            d="M756.5,516.22c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61c0,1.44,0.62,2.17,1.86,2.17
      h0.16c0.11,0,0.17,0.22,0.17,0.66V516.22z"
          />
          <path
            d="M763.46,514.13c0.03-0.17,0.05-0.37,0.05-0.6c0-0.26-0.01-0.52-0.04-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.51,1.36,1.35,1.36c0.85,0,1.28-0.61,1.28-1.84c0-0.59-0.13-1.32-0.38-2.19l1.47-0.4c0.29,0.91,0.43,1.75,0.42,2.53
      c0,0.02,0,0.03,0,0.05c-0.01,1.3-0.36,2.25-1.05,2.86c-0.43,0.38-1,0.57-1.71,0.57c-1.06,0-1.76-0.4-2.1-1.2
      c-0.58,0.81-1.4,1.21-2.45,1.21c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76
      v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.5c1.17,0,1.85-0.42,2.03-1.26c0.03-0.17,0.05-0.37,0.05-0.6c0-0.25-0.01-0.51-0.03-0.8
      l-0.05-0.52l1.42-0.17l0.14,1.99c0.06,0.91,0.59,1.37,1.58,1.37C762.75,515.4,763.3,514.98,763.46,514.13z"
          />
          <path d="M771.38,504.62h1.49v12.35h-1.49V504.62z" />
          <path
            d="M779.73,512.41l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.12,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L779.73,512.41z"
          />
          <path
            d="M781.94,516.98c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.52c1.89,0,4.23-0.72,7.01-2.16l0.64-0.33
      c-0.15-0.04-0.77-0.28-1.86-0.72c-1.12-0.45-1.89-0.68-2.29-0.68c-0.65,0-1.18,0.27-1.6,0.81l-0.24,0.31l-1.32-0.65l0.14-0.24
      c0.72-1.19,1.73-1.78,3.03-1.79c0.73,0,1.6,0.25,2.61,0.74c1.79,0.87,3.17,1.33,4.15,1.37l-0.02,1.5
      c-0.66,0.06-1.87,0.55-3.64,1.49c-2.46,1.29-4.69,1.94-6.71,1.94H781.94z M785.39,506.79l1.25-1.25l1.26,1.26l-1.25,1.25
      L785.39,506.79z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M681.3,712.75c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.99-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C677.56,711.68,678.81,712.75,681.3,712.75z M680.05,704.43l1.25-1.25l1.26,1.26l-1.25,1.25
      L680.05,704.43z"
          />
          <path
            d="M692.88,709.58c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V709.58z"
          />
          <path
            d="M695.17,709.11c-0.71,0.82-1.51,1.23-2.41,1.23h-0.18c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.14
      c0.46,0,0.92-0.27,1.38-0.81c0.19-0.24,0.41-0.63,0.65-1.17c0.75-1.66,1.73-2.5,2.95-2.5c0.95,0,1.69,0.34,2.23,1.02
      c0.54,0.68,0.82,1.47,0.82,2.38c0,0.89-0.19,1.56-0.58,2.01c-0.48,0.56-1.13,0.83-1.98,0.83
      C697.08,710.53,696.07,710.06,695.17,709.11z M698.07,708.99c0.8,0,1.2-0.39,1.2-1.18c0-0.37-0.06-0.69-0.17-0.96
      c-0.28-0.62-0.73-0.94-1.38-0.94c-0.79,0-1.39,0.59-1.81,1.78C696.67,708.56,697.38,708.99,698.07,708.99z"
          />
          <path
            d="M707.21,705.77l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.12,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.07
      c0-0.86-0.23-1.77-0.68-2.74L707.21,705.77z"
          />
          <path
            d="M714.65,704.67c0.75,0.81,1.11,1.7,1.09,2.66c-0.03,2-1.73,3.01-5.09,3.01h-1.23c-0.33,0-0.5-0.25-0.5-0.76v-0.16
      c0-0.44,0.17-0.66,0.5-0.66h1.22c2.37,0,3.55-0.55,3.56-1.64c0-0.56-0.3-1.12-0.89-1.68c-0.88-0.82-1.66-1.5-2.35-2.04
      c-0.65-0.51-0.98-1.05-0.98-1.61c0-0.74,0.4-1.27,1.2-1.57l5.96-2.26v1.55l-5.77,2.15C712.86,702.92,713.96,703.92,714.65,704.67z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M546.75,566.43c0.72,0.15,1.41,0.22,2.07,0.22c2.12,0,3.18-0.52,3.18-1.55c0-1.2-1.19-2.54-3.57-4.04l0.86-1.31
      c2.84,1.69,4.25,3.46,4.25,5.32c0,2.1-1.54,3.15-4.61,3.15c-0.84,0-1.57-0.07-2.18-0.21V566.43z"
          />
          <path
            d="M559.97,563.67l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.11,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L559.97,563.67z M557.48,560.54l1.29-1.29l1.3,1.3l-1.29,1.29L557.48,560.54z"
          />
          <path
            d="M562.83,568.24h-0.65c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.65c0.92,0,1.54-0.09,1.87-0.27
      c0.49-0.29,0.73-0.89,0.73-1.8c0-0.68-0.11-1.44-0.32-2.28l1.4-0.35c0.28,0.89,0.42,1.76,0.42,2.6c0,1.4-0.4,2.41-1.2,3.02
      C565.15,568.02,564.18,568.24,562.83,568.24z M562.05,570.96l1.25-1.25l1.26,1.26l-1.25,1.25L562.05,570.96z M564.85,570.96
      l1.25-1.25l1.26,1.26l-1.25,1.25L564.85,570.96z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M409.96,503.01c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C406.21,501.94,407.47,503.02,409.96,503.01z M408.71,494.7l1.25-1.25l1.26,1.26l-1.25,1.25
      L408.71,494.7z"
          />
          <path
            d="M421.54,499.85c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V499.85z"
          />
          <path
            d="M426.23,503.57c0.01-3.03,1.17-4.55,3.48-4.55h0.19c0.11,0,0.17,0.22,0.17,0.66v0.16c0,0.5-0.06,0.76-0.17,0.76h-0.21
      c-1.65,0-2.36,1.29-2.12,3.88l-1.06,1.02c-1.91-0.91-3.06-2.54-3.45-4.9h-1.82c-0.33,0-0.5-0.25-0.5-0.76v-0.16
      c0-0.44,0.17-0.66,0.5-0.66h1.71c0.12-2.46,0.58-4.13,1.4-5.01c0.47-0.5,1.05-0.76,1.75-0.76s1.25,0.25,1.66,0.74
      c0.41,0.5,0.61,1.18,0.61,2.07c-0.02,1.14-0.42,2.18-1.22,3.11c-0.77,0.91-1.67,1.39-2.68,1.44
      C424.7,501.97,425.29,502.96,426.23,503.57z M424.39,499.03c0.67-0.02,1.27-0.31,1.8-0.87c0.52-0.56,0.78-1.28,0.78-2.15
      c0-0.74-0.28-1.13-0.85-1.14C425.09,494.84,424.51,496.23,424.39,499.03z"
          />
          <path
            d="M434.67,499.5c-1,0.74-2.51,1.11-4.55,1.11h-0.35c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.35
      c1.49-0.01,2.47-0.1,2.93-0.28c-0.91-0.76-1.37-1.67-1.37-2.73c0-1,0.57-1.9,1.7-2.68c0.4-0.28,0.84-0.42,1.31-0.42
      c0.46,0,0.87,0.1,1.21,0.31c1.21,0.73,1.81,1.7,1.81,2.9c0,1-0.46,1.87-1.38,2.63c0.53,0.19,1.31,0.28,2.32,0.28h0.28
      c0.11,0,0.17,0.22,0.17,0.66v0.16c0,0.5-0.06,0.76-0.17,0.76h-0.26C436.99,500.61,435.66,500.24,434.67,499.5z M433.71,495.1
      c-0.34,0.34-0.52,0.67-0.52,1.01c0,0.35,0.18,0.74,0.55,1.16c0.42,0.49,0.74,0.73,0.96,0.73c0.22,0,0.54-0.24,0.96-0.73
      c0.37-0.42,0.55-0.81,0.55-1.15c0-0.42-0.26-0.84-0.78-1.25c-0.29-0.24-0.55-0.36-0.78-0.36S434.11,494.7,433.71,495.1z
       M433.41,490.03l1.25-1.25l1.26,1.26l-1.25,1.25L433.41,490.03z"
          />
          <path
            d="M441.86,499.36c-0.61,0.83-1.58,1.25-2.9,1.25h-0.15c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.51-0.66h0.14
      c1.28,0,1.99-0.38,2.12-1.13c0.06-0.35,0.07-0.87,0.03-1.53l-0.04-0.7l1.41-0.17l0.15,1.99c0.06,0.76,0.29,1.19,0.69,1.29
      c2.04-3.46,4.01-5.19,5.89-5.18c1.21,0,2.13,0.45,2.76,1.36c0.38,0.54,0.56,1.14,0.56,1.8c0,0.31-0.04,0.64-0.12,0.99
      c-0.44,1.91-2.5,2.87-6.17,2.87h-0.44C443.66,500.61,442.35,500.19,441.86,499.36z M444.95,499.02h1.32c1.59,0,2.73-0.15,3.42-0.46
      c0.83-0.37,1.25-0.94,1.25-1.71c0-0.37-0.1-0.68-0.3-0.94c-0.34-0.44-0.81-0.66-1.43-0.67
      C447.98,495.24,446.55,496.5,444.95,499.02z"
          />
          <path d="M454.77,488.25h1.49v12.35h-1.49V488.25z" />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M618.58,842c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C614.83,840.93,616.08,842,618.58,842z M617.32,833.69l1.25-1.25l1.26,1.26l-1.25,1.25
      L617.32,833.69z"
          />
          <path
            d="M630.16,838.84c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V838.84z"
          />
          <path
            d="M635.08,833.92c0.75,0.81,1.11,1.7,1.09,2.66c-0.03,2-1.73,3.01-5.09,3.01h-1.23c-0.33,0-0.5-0.25-0.5-0.76v-0.16
      c0-0.44,0.17-0.66,0.5-0.66h1.22c2.37,0,3.55-0.55,3.56-1.64c0-0.56-0.3-1.12-0.89-1.68c-0.88-0.82-1.66-1.5-2.35-2.04
      c-0.65-0.51-0.98-1.04-0.98-1.61c0-0.75,0.4-1.27,1.2-1.57l5.96-2.26v1.56l-5.77,2.15C633.29,832.18,634.39,833.18,635.08,833.92z
       M637.51,825.96l-6.72,2.59v-1.1l6.72-2.59V825.96z"
          />
          <path
            d="M643.63,835.02l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33H646c0.11,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L643.63,835.02z M641.14,831.89l1.29-1.29l1.3,1.3l-1.29,1.29L641.14,831.89z"
          />
          <path
            d="M648.43,838.36c-0.71,0.82-1.51,1.23-2.41,1.23h-0.18c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.14
      c0.46,0,0.92-0.27,1.38-0.81c0.19-0.24,0.41-0.63,0.65-1.17c0.75-1.66,1.73-2.49,2.95-2.5c0.95,0,1.69,0.34,2.23,1.02
      c0.54,0.68,0.82,1.47,0.82,2.38c0,0.89-0.19,1.56-0.58,2.01c-0.48,0.56-1.13,0.83-1.98,0.83
      C650.34,839.78,649.33,839.31,648.43,838.36z M651.33,838.24c0.8,0,1.2-0.39,1.2-1.18c0-0.37-0.06-0.69-0.17-0.96
      c-0.28-0.62-0.73-0.94-1.38-0.94c-0.79,0-1.39,0.59-1.81,1.78C649.93,837.81,650.64,838.24,651.33,838.24z"
          />
          <path
            d="M660.47,835.02l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.12,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L660.47,835.02z"
          />
          <path
            d="M663.57,839.59h-0.88c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h2.28h0.43
      c-0.24-0.17-0.44-0.33-0.58-0.51c-0.44-0.51-0.66-1.08-0.65-1.7c0-0.7,0.24-1.33,0.73-1.89c0.6-0.69,1.36-1.04,2.29-1.04
      c0.85,0,1.56,0.27,2.13,0.81c0.49,0.45,0.73,1.03,0.74,1.75c0,1.04-0.45,1.83-1.36,2.39c0.92,0.13,1.52,0.2,1.79,0.2
      c0.39,0,0.69-0.04,0.9-0.12c0.62-0.25,0.94-0.7,0.95-1.36c0.01-1.38-1.62-2.86-4.91-4.44l0.75-1.31c3.83,1.86,5.73,3.78,5.7,5.77
      c-0.01,0.85-0.27,1.55-0.77,2.1c-0.56,0.62-1.43,0.94-2.61,0.94c-0.89,0.01-1.99-0.2-3.29-0.61
      C665.79,839.39,664.59,839.59,663.57,839.59z M668.09,836.74c0.39-0.38,0.59-0.79,0.61-1.25c0-0.3-0.08-0.54-0.25-0.72
      c-0.31-0.34-0.71-0.51-1.19-0.51c-0.58,0-1.03,0.25-1.32,0.75c-0.14,0.23-0.21,0.5-0.21,0.83c0,0.36,0.17,0.7,0.52,1.01
      c0.16,0.14,0.33,0.26,0.52,0.34c0.14,0.07,0.28,0.12,0.43,0.16c0.09-0.04,0.17-0.08,0.26-0.13
      C667.69,837.07,667.91,836.91,668.09,836.74z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M392.32,734.15l-1.32,1.12c-0.71,0.59-0.9,1.27-0.56,2.03l0.1,0.22c0.05,0.11-0.12,0.24-0.5,0.41l-0.19,0.08
      c-0.46,0.2-0.72,0.25-0.76,0.15l-0.06-0.13c-0.33-0.74-0.4-1.28-0.21-1.62c-2.62,0.8-4.84-0.39-6.66-3.56l1.19-0.92
      c1.61,2.84,3.5,3.78,5.68,2.82c0.79-0.35,1.53-0.92,2.24-1.72L392.32,734.15z"
          />
          <path
            d="M388.32,743.78c2.78-1.21,4.63-0.76,5.56,1.36l0.08,0.17c0.05,0.1-0.13,0.25-0.54,0.42l-0.15,0.07
      c-0.46,0.2-0.72,0.25-0.76,0.15l-0.08-0.19c-0.66-1.51-2.13-1.64-4.4-0.38l-1.36-0.56c0.06-2.12,1.09-3.82,3.1-5.12l-0.73-1.67
      c-0.13-0.3,0.03-0.56,0.49-0.76l0.15-0.07c0.4-0.18,0.67-0.11,0.81,0.19l0.69,1.57c2.3-0.88,4.01-1.13,5.15-0.73
      c0.65,0.23,1.12,0.66,1.4,1.29c0.28,0.64,0.28,1.24-0.01,1.82c-0.29,0.58-0.84,1.04-1.65,1.39c-1.05,0.44-2.16,0.49-3.34,0.13
      c-1.15-0.34-1.94-0.97-2.39-1.88C389.17,741.73,388.5,742.67,388.32,743.78z M391.74,740.27c0.29,0.61,0.79,1.04,1.52,1.29
      c0.72,0.25,1.48,0.2,2.28-0.15c0.68-0.3,0.92-0.71,0.7-1.24C395.86,739.22,394.35,739.25,391.74,740.27z"
          />
          <path
            d="M397.98,751.31c0.17-0.04,0.36-0.1,0.57-0.19c0.24-0.1,0.48-0.22,0.72-0.35l0.45-0.26l0.73,1.23l-1.76,0.92
      c-0.8,0.42-1.04,1.02-0.7,1.78c0.34,0.78,1.08,0.92,2.2,0.43c0.54-0.24,1.16-0.65,1.85-1.23l0.95,1.19
      c-0.71,0.63-1.43,1.09-2.14,1.4c-0.02,0.01-0.03,0.01-0.05,0.02c-1.19,0.52-2.21,0.58-3.04,0.19c-0.52-0.24-0.92-0.69-1.21-1.34
      c-0.43-0.97-0.34-1.77,0.26-2.4c-0.97-0.2-1.67-0.79-2.1-1.75c-0.49-1.12-0.43-2.01,0.16-2.64c-0.92-0.09-1.67-0.78-2.23-2.05
      l-0.19-0.44c-0.13-0.3,0.03-0.56,0.49-0.76l0.15-0.07c0.4-0.18,0.67-0.11,0.81,0.19l0.2,0.46c0.47,1.08,1.13,1.52,1.97,1.35
      c0.17-0.04,0.36-0.1,0.57-0.2c0.23-0.1,0.46-0.22,0.72-0.35l0.45-0.25l0.73,1.23l-1.76,0.93c-0.81,0.42-1.01,1.09-0.61,2
      C396.54,751.17,397.14,751.5,397.98,751.31z M401.93,747.28l1.61,0.62l-0.63,1.62l-1.61-0.63L401.93,747.28z M403.05,749.83
      l1.61,0.63l-0.63,1.62l-1.61-0.63L403.05,749.83z M404.6,747.6l1.61,0.63l-0.63,1.62l-1.61-0.63L404.6,747.6z"
          />
          <path
            d="M402.22,764.1l0.36,0.81c0.05,0.1-0.15,0.26-0.6,0.45l-0.08,0.03c-0.46,0.2-0.72,0.25-0.76,0.15l-0.38-0.88
      c-2.43,0.6-4.5-0.6-6.2-3.61l1.2-0.92c1.37,2.37,2.84,3.45,4.42,3.25l-0.51-1.15c-0.84-1.92-0.48-3.22,1.08-3.91
      c0.63-0.28,1.29-0.41,1.98-0.38c1.25,0.04,2.09,0.56,2.53,1.55C405.96,761.07,404.95,762.61,402.22,764.1z M401.65,762.78
      c1.78-0.93,2.48-1.84,2.09-2.74c-0.21-0.5-0.68-0.72-1.42-0.66c-0.32,0.03-0.61,0.1-0.87,0.21c-0.68,0.3-0.8,0.94-0.37,1.92
      L401.65,762.78z"
          />
          <path
            d="M399.04,767.53l1.65,0.64l-0.65,1.66l-1.65-0.64L399.04,767.53z M401.34,766.02l-0.26-0.6c-0.13-0.3,0.03-0.56,0.49-0.76
      l0.15-0.07c0.4-0.18,0.67-0.11,0.81,0.19l0.26,0.6c0.37,0.84,0.7,1.37,1,1.6c0.46,0.33,1.1,0.31,1.94-0.05
      c0.62-0.27,1.28-0.68,1.96-1.21l0.89,1.14c-0.71,0.62-1.44,1.09-2.21,1.43c-1.28,0.57-2.37,0.6-3.24,0.11
      C402.48,768.05,401.89,767.25,401.34,766.02z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M488.08,746.99c-0.66,0-1.18-0.16-1.57-0.48c-0.01,0.77-0.19,1.56-0.57,2.35c-0.84,1.74-2.55,2.6-5.13,2.6
      c-3.47,0-5.2-1.61-5.2-4.82c0-1.17,0.29-2.46,0.87-3.86l1.37,0.56c-0.48,1.21-0.72,2.31-0.72,3.28c0,2.21,1.25,3.32,3.75,3.32
      c2.72,0,4.09-1.27,4.1-3.82c0-1.05-0.26-2.11-0.78-3.18l1.49-0.51l0.52,1.59c0.29,0.91,0.93,1.37,1.91,1.37
      c1.11,0,1.66-0.55,1.66-1.64c0-0.48-0.01-0.8-0.03-0.99l-0.04-0.52l1.42-0.17l0.14,1.99c0.06,0.89,0.51,1.33,1.36,1.33
      c0.85,0,1.27-0.61,1.26-1.81c0-0.59-0.13-1.32-0.38-2.19l1.47-0.4c0.29,0.9,0.43,1.76,0.42,2.58c0,1.3-0.35,2.25-1.04,2.86
      c-0.44,0.38-1.01,0.57-1.72,0.57c-1.06,0-1.76-0.4-2.1-1.2C489.94,746.59,489.13,746.99,488.08,746.99z"
          />
          <path
            d="M501.82,742.42c0.48,1.09,0.72,2.15,0.72,3.16c0,3.32-2,5.2-6.01,5.62l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.88-0.22-1.79-0.67-2.75L501.82,742.42z"
          />
          <path
            d="M508.43,746.24c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V746.24z"
          />
          <path
            d="M512.02,743.8c-1.86,0-2.8-0.78-2.83-2.33c0-0.25,0.02-0.48,0.07-0.71c0.17-0.9,0.5-1.6,0.98-2.1
      c0.48-0.49,1.07-0.74,1.78-0.74c0.48,0,0.9,0.12,1.26,0.35c0.96,0.62,1.54,1.82,1.74,3.59c0.04,0.37,0.06,0.72,0.06,1.06
      c0,1.62-0.39,2.72-1.16,3.3c-0.69,0.52-1.9,0.77-3.63,0.77h-2.17c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h2.26
      c2.18,0,3.3-0.57,3.35-1.7c0-0.05,0-0.1-0.01-0.15C513.21,743.72,512.63,743.8,512.02,743.8z M510.54,735.31l1.25-1.25l1.26,1.26
      l-1.25,1.25L510.54,735.31z M510.61,741.24c0,0.72,0.51,1.07,1.52,1.07c0.48,0,0.97-0.07,1.46-0.22c-0.08-0.67-0.23-1.23-0.44-1.68
      c-0.28-0.62-0.68-0.93-1.19-0.93c-0.6,0-1.01,0.38-1.25,1.15C510.65,740.83,510.61,741.04,510.61,741.24z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M224.93,614.7c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C221.18,613.63,222.43,614.7,224.93,614.7z M223.67,606.39l1.25-1.25l1.26,1.26l-1.25,1.25
      L223.67,606.39z"
          />
          <path
            d="M236.51,611.54c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V611.54z"
          />
          <path
            d="M242.67,611.54c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.04-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.98c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V611.54
      z M236.19,604.02l1.25-1.25l1.26,1.26l-1.25,1.25L236.19,604.02z M238.99,604.02l1.25-1.25l1.26,1.26l-1.25,1.25L238.99,604.02z"
          />
          <path
            d="M249.63,609.45c0.03-0.17,0.05-0.37,0.05-0.6c0-0.26-0.01-0.52-0.04-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.51,1.36,1.35,1.36c0.85,0,1.28-0.61,1.28-1.84c0-0.59-0.13-1.32-0.38-2.19l1.47-0.4c0.29,0.91,0.43,1.75,0.42,2.53
      c0,0.02,0,0.03,0,0.05c-0.01,1.3-0.36,2.25-1.05,2.86c-0.43,0.38-1,0.57-1.71,0.57c-1.06,0-1.76-0.4-2.1-1.2
      c-0.58,0.81-1.4,1.21-2.45,1.21c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76
      v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.5c1.17,0,1.85-0.42,2.03-1.26c0.03-0.17,0.05-0.37,0.05-0.6c0-0.25-0.01-0.51-0.03-0.8
      l-0.05-0.52l1.42-0.17l0.14,1.99c0.06,0.91,0.59,1.37,1.58,1.37C248.92,610.71,249.47,610.29,249.63,609.45z"
          />
          <path
            d="M261.72,607.72c0.48,1.09,0.72,2.15,0.72,3.16c0,3.32-2,5.2-6.01,5.62l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.88-0.22-1.79-0.67-2.75L261.72,607.72z M259.23,604.59l1.29-1.29l1.3,1.3l-1.29,1.29L259.23,604.59z"
          />
          <path
            d="M270.13,610.72h0.88c0.11,0,0.17,0.24,0.17,0.73v0.09c0,0.5-0.06,0.76-0.17,0.76l-0.96-0.01c-0.43,2.47-2.36,3.88-5.8,4.22
      l-0.36-1.47c2.71-0.3,4.3-1.21,4.75-2.74h-1.25c-2.1,0-3.15-0.85-3.15-2.56c0-0.69,0.15-1.35,0.45-1.97
      c0.54-1.13,1.35-1.69,2.44-1.69C268.86,606.07,269.86,607.62,270.13,610.72z M268.69,610.71c-0.13-2-0.69-3.01-1.67-3.02
      c-0.54-0.01-0.93,0.34-1.18,1.03c-0.1,0.3-0.16,0.6-0.16,0.88c0,0.74,0.54,1.11,1.61,1.11H268.69z"
          />
          <path
            d="M270.88,612.29c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.52c1.89,0,4.23-0.72,7.01-2.16l0.64-0.33
      c-0.15-0.04-0.77-0.28-1.86-0.72c-1.12-0.45-1.89-0.68-2.29-0.68c-0.65,0-1.18,0.27-1.6,0.81l-0.24,0.31l-1.32-0.65l0.14-0.24
      c0.72-1.19,1.73-1.78,3.03-1.79c0.73,0,1.6,0.25,2.61,0.74c1.79,0.87,3.17,1.33,4.15,1.37l-0.02,1.5
      c-0.66,0.06-1.87,0.55-3.64,1.49c-2.46,1.29-4.69,1.94-6.71,1.94H270.88z M274.33,602.11l1.25-1.25l1.26,1.26l-1.25,1.25
      L274.33,602.11z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M143.96,495.8c0,0.81-0.2,1.49-0.59,2.02c-0.4,0.56-1.04,0.83-1.91,0.83c-0.58,0-1.29-0.25-2.11-0.76
      c-0.27-0.17-0.57-0.33-0.88-0.49c-0.19-0.1-0.41-0.14-0.65-0.14c-0.88,0.01-1.31,1.43-1.31,4.26c0,1.12,0.04,2.15,0.12,3.07h-1.55
      c-0.07-1.09-0.1-2.12-0.09-3.1c0.02-2.08,0.24-3.55,0.68-4.41c0.45-0.88,1.06-1.38,1.85-1.5c0.84-2.13,1.98-3.19,3.4-3.2
      c0.93-0.01,1.67,0.33,2.22,1C143.68,494.07,143.96,494.87,143.96,495.8z M141.37,497.1c0.75,0.01,1.12-0.39,1.12-1.19
      c-0.01-0.33-0.07-0.65-0.19-0.95c-0.25-0.61-0.7-0.92-1.36-0.94c-0.78-0.01-1.38,0.58-1.81,1.78
      C140.12,496.67,140.87,497.1,141.37,497.1z"
          />
          <path
            d="M150.51,496.54c1.32-0.42,1.98-1.61,1.98-3.58v-6.86h1.49v7.64c0,2.09,0.6,3.14,1.81,3.14H156c0.11,0,0.17,0.22,0.17,0.66
      v0.16c0,0.5-0.06,0.76-0.17,0.76h-0.34c-1.39,0-2.27-0.65-2.65-1.94c-0.93,1.28-2.53,1.92-4.8,1.92c-0.79,0-1.43-0.05-1.92-0.14
      v-1.56c0.96,0.13,1.9,0.16,2.81,0.1c-0.82-2.81-1.98-5.95-3.48-9.42l1.42-0.81C148.57,490.29,149.72,493.6,150.51,496.54z"
          />
          <path
            d="M156.51,498.46h-0.65c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.65c0.92,0,1.54-0.09,1.87-0.27
      c0.49-0.29,0.73-0.89,0.73-1.8c0-0.68-0.11-1.44-0.32-2.28l1.4-0.35c0.28,0.89,0.42,1.76,0.42,2.6c0,1.4-0.4,2.41-1.2,3.02
      C158.82,498.24,157.86,498.46,156.51,498.46z M155.73,501.18l1.25-1.25l1.26,1.26l-1.25,1.25L155.73,501.18z M158.53,501.18
      l1.25-1.25l1.26,1.26l-1.25,1.25L158.53,501.18z"
          />
          <path d="M163.16,486.1h1.49v12.35h-1.49V486.1z" />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M201.86,485.63c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C198.12,484.56,199.37,485.63,201.86,485.63z M200.61,477.31l1.25-1.25l1.26,1.26l-1.25,1.25
      L200.61,477.31z"
          />
          <path
            d="M213.45,482.46c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V482.46z"
          />
          <path
            d="M219.61,482.46c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.04-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.98c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V482.46
      z M213.13,474.95l1.25-1.25l1.26,1.26l-1.25,1.25L213.13,474.95z M215.92,474.95l1.25-1.25l1.26,1.26l-1.25,1.25L215.92,474.95z"
          />
          <path
            d="M226.57,480.38c0.03-0.17,0.05-0.37,0.05-0.6c0-0.26-0.01-0.52-0.04-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.51,1.36,1.35,1.36c0.85,0,1.28-0.61,1.28-1.84c0-0.59-0.13-1.32-0.38-2.19l1.47-0.4c0.29,0.91,0.43,1.75,0.42,2.53
      c0,0.02,0,0.03,0,0.05c-0.01,1.3-0.36,2.25-1.05,2.86c-0.43,0.38-1,0.57-1.71,0.57c-1.06,0-1.76-0.4-2.1-1.2
      c-0.58,0.81-1.4,1.21-2.45,1.21c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76
      v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.5c1.17,0,1.85-0.42,2.03-1.26c0.03-0.17,0.05-0.37,0.05-0.6c0-0.25-0.01-0.51-0.03-0.8
      l-0.05-0.52l1.42-0.17l0.14,1.99c0.06,0.91,0.59,1.37,1.58,1.37C225.86,481.64,226.4,481.22,226.57,480.38z"
          />
          <path
            d="M238.65,478.65l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.12,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L238.65,478.65z"
          />
          <path
            d="M240.87,483.22c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.41c1.53,0,2.29-0.72,2.29-2.16v-8.62h1.5
      v8.67c0,2.46-1.28,3.69-3.83,3.69H240.87z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M107.9,414.29c2.62,1.91,3.94,3.65,3.94,5.23c0,1.08-0.47,1.92-1.42,2.5c-0.45,0.29-1.05,0.43-1.8,0.44
      c-0.69,0-1.29-0.12-1.78-0.37c-0.96-0.48-1.44-1.34-1.44-2.57c0-1.18,0.68-2.43,2.04-3.76l-0.39-0.33L107.9,414.29z M108.49,416.96
      c-1.09,0.95-1.63,1.79-1.63,2.52c0,0.96,0.58,1.44,1.75,1.44c1.18,0,1.77-0.48,1.76-1.44
      C110.36,418.79,109.74,417.96,108.49,416.96z"
          />
          <path
            d="M117.68,421.74c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V421.74z"
          />
          <path
            d="M126.15,419.55c0.06,0.91,0.52,1.36,1.37,1.36c0.86,0,1.29-0.57,1.28-1.71c0-0.45-0.01-0.82-0.04-1.12l-0.04-0.52
      l1.42-0.17l0.14,1.63c0.11,1.27,0.64,1.9,1.59,1.9h0.16c0.11,0,0.17,0.22,0.17,0.66v0.16c0,0.5-0.06,0.76-0.17,0.76h-0.14
      c-1.15,0-1.86-0.41-2.14-1.23c-0.41,0.82-1.13,1.23-2.17,1.23s-1.74-0.4-2.13-1.21c-0.58,0.81-1.39,1.21-2.45,1.21
      c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66
      h0.5c1.18,0,1.86-0.42,2.04-1.26c0.03-0.14,0.04-0.34,0.04-0.6c0-0.25-0.01-0.51-0.03-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.59,1.37,1.58,1.37c0.92,0,1.47-0.42,1.63-1.26c0.03-0.14,0.04-0.34,0.04-0.6c0-0.26-0.01-0.52-0.03-0.8l-0.05-0.52
      l1.42-0.17L126.15,419.55z M122.52,414.41l1.21-1.22l1.23,1.23l-1.22,1.22L122.52,414.41z M123.89,412.1l1.22-1.22l1.23,1.23
      l-1.22,1.22L123.89,412.1z M125.31,414.41l1.22-1.22l1.23,1.23l-1.22,1.22L125.31,414.41z"
          />
          <path
            d="M132.53,422.49h-0.65c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.65c0.92,0,1.54-0.09,1.87-0.27
      c0.49-0.29,0.73-0.89,0.73-1.8c0-0.68-0.11-1.44-0.32-2.28l1.4-0.35c0.28,0.89,0.42,1.76,0.42,2.6c0,1.4-0.4,2.41-1.2,3.02
      C134.84,422.27,133.88,422.49,132.53,422.49z M133.48,413.5l1.25-1.25l1.26,1.26l-1.25,1.25L133.48,413.5z"
          />
          <path
            d="M142.55,421.74c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V421.74z"
          />
          <path
            d="M144.84,421.27c-0.71,0.82-1.51,1.23-2.41,1.23h-0.18c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.14
      c0.46,0,0.92-0.27,1.38-0.81c0.19-0.24,0.41-0.63,0.65-1.17c0.75-1.66,1.73-2.49,2.95-2.5c0.95,0,1.69,0.34,2.23,1.02
      c0.54,0.68,0.82,1.47,0.82,2.38c0,0.89-0.19,1.56-0.58,2.01c-0.48,0.56-1.13,0.83-1.98,0.83
      C146.75,422.68,145.74,422.21,144.84,421.27z M147.74,421.15c0.8,0,1.2-0.39,1.2-1.18c0-0.37-0.06-0.69-0.17-0.96
      c-0.28-0.62-0.73-0.94-1.38-0.94c-0.79,0-1.39,0.59-1.81,1.78C146.34,420.71,147.06,421.15,147.74,421.15z"
          />
          <path
            d="M156.88,417.92l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.12,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L156.88,417.92z"
          />
          <path
            d="M164.32,416.82c0.75,0.81,1.11,1.7,1.09,2.66c-0.03,2-1.73,3.01-5.09,3.01h-1.23c-0.33,0-0.5-0.25-0.5-0.76v-0.16
      c0-0.44,0.17-0.66,0.5-0.66h1.22c2.37,0,3.55-0.55,3.56-1.64c0-0.56-0.3-1.12-0.89-1.68c-0.88-0.82-1.66-1.5-2.35-2.04
      c-0.65-0.51-0.98-1.05-0.98-1.61c0-0.74,0.4-1.27,1.2-1.57l5.96-2.26v1.56l-5.77,2.15C162.53,415.08,163.63,416.08,164.32,416.82z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M229.82,402.81c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C226.08,401.74,227.33,402.82,229.82,402.81z M228.57,394.5l1.25-1.25l1.26,1.26l-1.25,1.25
      L228.57,394.5z"
          />
          <path d="M237.73,388.05h1.49v12.35h-1.49V388.05z" />
          <path
            d="M243.86,400.4c-0.77,0-1.59-0.08-2.46-0.25v-1.58c0.8,0.17,1.63,0.25,2.5,0.25c1.8,0,2.71-0.41,2.71-1.24
      c0-0.36-0.26-1.16-0.78-2.4l-1.09-2.59l1.42-0.65l1.7,4.32c0.67,1.71,1.35,2.56,2.03,2.56h0.17c0.12,0,0.17,0.22,0.17,0.66v0.16
      c0,0.19-0.01,0.33-0.03,0.43c-0.02,0.11-0.04,0.2-0.06,0.25c-0.03,0.05-0.06,0.08-0.09,0.08h-0.17c-0.96,0-1.71-0.46-2.25-1.38
      C246.88,399.94,245.62,400.4,243.86,400.4z"
          />
          <path
            d="M255.53,400.59c-1.05,0-2.06-0.47-3.01-1.42c-0.71,0.82-1.51,1.23-2.41,1.23h-0.18c-0.33,0-0.49-0.25-0.49-0.76v-0.16
      c0-0.44,0.16-0.66,0.49-0.66h0.14c0.53,0,0.99-0.27,1.38-0.81c0.21-0.29,0.42-0.68,0.64-1.18c0.74-1.66,1.73-2.49,2.95-2.49
      c0.93,0,1.66,0.34,2.2,1.02c0.38,0.49,0.65,1.11,0.81,1.84c0.23,1.08,0.68,1.62,1.36,1.62h0.13c0.11,0,0.17,0.22,0.17,0.66v0.16
      c0,0.5-0.06,0.76-0.17,0.76h-0.14c-0.66,0-1.2-0.32-1.62-0.96C257.29,400.21,256.54,400.59,255.53,400.59z M255.43,399.06
      c0.83,0.01,1.24-0.39,1.22-1.19c0-0.33-0.07-0.65-0.2-0.95c-0.28-0.62-0.74-0.93-1.39-0.94c-0.77-0.01-1.37,0.58-1.8,1.78
      C254,398.62,254.73,399.05,255.43,399.06z"
          />
          <path
            d="M260.29,400.41h-0.88c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h2.28h0.43
      c-0.24-0.17-0.44-0.33-0.58-0.51c-0.44-0.51-0.66-1.08-0.65-1.7c0-0.7,0.24-1.33,0.73-1.89c0.6-0.69,1.36-1.04,2.29-1.04
      c0.85,0,1.56,0.27,2.13,0.81c0.49,0.45,0.73,1.03,0.74,1.74c0,1.04-0.45,1.83-1.36,2.39c0.92,0.13,1.52,0.2,1.79,0.2
      c0.39,0,0.69-0.04,0.9-0.12c0.62-0.25,0.94-0.7,0.95-1.36c0.01-1.38-1.62-2.86-4.91-4.44l0.75-1.31c3.83,1.86,5.73,3.78,5.7,5.77
      c-0.01,0.85-0.27,1.55-0.77,2.1c-0.56,0.62-1.43,0.94-2.61,0.94c-0.89,0.01-1.99-0.2-3.29-0.61
      C262.51,400.2,261.31,400.41,260.29,400.41z M264.81,397.55c0.39-0.38,0.59-0.79,0.61-1.25c0-0.3-0.08-0.54-0.25-0.72
      c-0.31-0.34-0.71-0.51-1.19-0.51c-0.58,0-1.03,0.25-1.32,0.75c-0.14,0.23-0.21,0.5-0.21,0.82c0,0.36,0.17,0.7,0.52,1.01
      c0.16,0.14,0.33,0.26,0.52,0.34c0.14,0.07,0.28,0.12,0.43,0.15c0.09-0.03,0.17-0.08,0.26-0.13
      C264.41,397.88,264.62,397.72,264.81,397.55z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M288.37,436.98c0,2.08,1.35,3.12,4.06,3.14c1.02,0,1.93-0.19,2.73-0.56c0.42-0.19,0.79-0.45,1.1-0.77
      c0.31-0.33,0.47-0.7,0.47-1.11c0-0.33-0.22-0.49-0.67-0.49l-0.98-0.01c-1.43-0.01-2.14-0.58-2.14-1.71c0-1.08,0.34-2,1.03-2.75
      c0.89-0.97,2.14-1.45,3.75-1.45h0.18v1.66h-0.19c-0.92,0-1.68,0.21-2.28,0.63c-0.61,0.43-0.92,0.96-0.94,1.58
      c0,0.17,0.05,0.29,0.14,0.37c0.1,0.08,0.25,0.12,0.46,0.12h1.02c1.36-0.01,2.04,0.56,2.04,1.71c0,1.66-0.82,2.87-2.47,3.63
      c-0.97,0.44-2.07,0.66-3.3,0.66c-3.68,0-5.53-1.54-5.53-4.61c0-1.23,0.4-2.75,1.19-4.55l1.37,0.56
      C288.72,434.61,288.37,435.93,288.37,436.98z"
          />
          <path
            d="M304.63,432.76l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.11,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L304.63,432.76z M302.13,429.63l1.29-1.29l1.3,1.3l-1.29,1.29L302.13,429.63z"
          />
          <path
            d="M312.06,431.66c0.75,0.81,1.11,1.7,1.09,2.66c-0.03,2-1.73,3.01-5.09,3.01h-1.23c-0.33,0-0.5-0.25-0.5-0.76v-0.16
      c0-0.44,0.17-0.66,0.5-0.66h1.22c2.37,0,3.55-0.55,3.56-1.64c0-0.56-0.3-1.12-0.89-1.68c-0.88-0.82-1.66-1.5-2.35-2.04
      c-0.65-0.51-0.98-1.05-0.98-1.61c0-0.74,0.4-1.27,1.2-1.57l5.96-2.26v1.56l-5.77,2.15C310.27,429.91,311.37,430.91,312.06,431.66z"
          />
          <path
            d="M320.6,432.76l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.12,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L320.6,432.76z"
          />
          <path
            d="M325.41,436.1c-0.71,0.82-1.51,1.23-2.41,1.23h-0.18c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.14
      c0.46,0,0.92-0.27,1.38-0.81c0.19-0.24,0.41-0.63,0.65-1.17c0.75-1.66,1.73-2.49,2.95-2.5c0.95,0,1.69,0.34,2.23,1.02
      c0.54,0.68,0.82,1.47,0.82,2.38c0,0.89-0.19,1.56-0.58,2.01c-0.48,0.56-1.13,0.83-1.98,0.83
      C327.32,437.52,326.31,437.05,325.41,436.1z M328.31,435.98c0.8,0,1.2-0.39,1.2-1.18c0-0.37-0.06-0.69-0.17-0.96
      c-0.28-0.62-0.73-0.94-1.38-0.94c-0.79,0-1.39,0.59-1.81,1.78C326.9,435.55,327.62,435.98,328.31,435.98z"
          />
        </g>
        <text
          transform="matrix(1 0 0 1 359.3041 404.9679)"
          style={{ fill: textColor }}
        >
          قم
        </text>
        <g style={{ fill: textColor }}>
          <path
            d="M385.36,356.32c2.01-0.01,3.01-0.94,3.01-2.8c0-0.81-0.19-1.61-0.57-2.39l1.09-0.39c0.41,1.03,0.62,1.96,0.62,2.78
      c0,0.78-0.15,1.46-0.43,2.03c-0.63,1.26-1.89,1.88-3.78,1.88c-2.54,0-3.82-1.17-3.82-3.5c0-0.9,0.21-1.86,0.63-2.89l1.01,0.41
      c-0.35,0.89-0.53,1.72-0.52,2.49C382.6,355.53,383.52,356.33,385.36,356.32z M384.43,350.2l0.92-0.92l0.93,0.93l-0.92,0.92
      L384.43,350.2z"
          />
          <path d="M391.18,345.45h1.1v9.1h-1.1V345.45z" />
          <path
            d="M397.32,351.18l0.36,1.22c0.19,0.65,0.59,0.98,1.2,0.98h0.18c0.08,0,0.13,0.15,0.13,0.46v0.15c0,0.37-0.04,0.56-0.13,0.56
      h-0.11c-0.6,0-0.98-0.11-1.15-0.34c-0.24,2-1.7,3.15-4.37,3.44l-0.27-1.08c2.39-0.24,3.59-1.24,3.58-2.99
      c0-0.63-0.17-1.31-0.5-2.02L397.32,351.18z"
          />
          <path
            d="M402.64,356.73c0-2.23,0.86-3.35,2.56-3.35h0.14c0.08,0,0.13,0.16,0.13,0.49v0.12c0,0.37-0.04,0.56-0.13,0.56h-0.15
      c-1.21,0-1.74,0.95-1.56,2.85l-0.78,0.75c-1.41-0.67-2.26-1.87-2.54-3.61h-1.34c-0.24,0-0.37-0.19-0.37-0.56v-0.12
      c0-0.32,0.12-0.49,0.37-0.49h1.26c0.08-1.81,0.43-3.04,1.03-3.69c0.35-0.37,0.78-0.56,1.29-0.56s0.92,0.18,1.22,0.55
      c0.3,0.37,0.45,0.87,0.45,1.52c-0.01,0.84-0.31,1.6-0.9,2.29c-0.57,0.67-1.23,1.02-1.98,1.06
      C401.51,355.56,401.94,356.28,402.64,356.73z M401.28,353.39c0.49-0.01,0.93-0.23,1.32-0.64c0.38-0.41,0.58-0.94,0.58-1.58
      c0-0.55-0.21-0.83-0.63-0.84C401.79,350.3,401.37,351.32,401.28,353.39z"
          />
          <path
            d="M405.72,354.55h-0.48c-0.24,0-0.37-0.19-0.37-0.56v-0.12c0-0.32,0.12-0.49,0.37-0.49h0.48c0.68,0,1.13-0.07,1.37-0.2
      c0.36-0.21,0.54-0.65,0.54-1.32c0-0.5-0.08-1.06-0.23-1.68l1.03-0.26c0.21,0.66,0.31,1.3,0.31,1.92c0,1.03-0.3,1.77-0.89,2.22
      C407.42,354.39,406.71,354.55,405.72,354.55z M405.24,347.93l0.92-0.92l0.93,0.93l-0.92,0.92L405.24,347.93z M407.3,347.93
      l0.92-0.92l0.93,0.93l-0.92,0.92L407.3,347.93z"
          />
        </g>
        <g style={{ fill: textColor, transform: 'translateX(30px)' }}>
          <path
            d="M395.18,312.14c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C391.44,311.07,392.69,312.15,395.18,312.14z M393.93,303.83l1.25-1.25l1.26,1.26l-1.25,1.25
      L393.93,303.83z"
          />
          <path d="M403.08,297.38h1.49v12.35h-1.49V297.38z" />
          <path
            d="M411.44,305.17c0.48,1.09,0.72,2.15,0.72,3.16c0,3.32-2,5.2-6.01,5.62l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.88-0.22-1.79-0.67-2.75L411.44,305.17z"
          />
          <path
            d="M416.32,309.73c-0.77,0-1.59-0.08-2.46-0.25v-1.58c0.8,0.17,1.63,0.25,2.5,0.25c1.8,0,2.71-0.41,2.71-1.24
      c0-0.36-0.26-1.16-0.78-2.4l-1.09-2.59l1.42-0.65l1.7,4.32c0.67,1.71,1.35,2.56,2.03,2.56h0.17c0.12,0,0.17,0.22,0.17,0.66v0.16
      c0,0.19-0.01,0.33-0.03,0.43c-0.02,0.11-0.04,0.2-0.06,0.25c-0.03,0.05-0.06,0.08-0.09,0.08h-0.17c-0.96,0-1.71-0.46-2.25-1.38
      C419.33,309.27,418.08,309.73,416.32,309.73z"
          />
          <path
            d="M423.04,309.74h-0.65c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.65c0.92,0,1.54-0.09,1.87-0.27
      c0.49-0.29,0.73-0.89,0.73-1.8c0-0.68-0.11-1.44-0.32-2.28l1.4-0.35c0.28,0.89,0.42,1.76,0.42,2.6c0,1.4-0.4,2.41-1.2,3.02
      C425.35,309.52,424.38,309.74,423.04,309.74z M423.98,300.75l1.25-1.25l1.26,1.26l-1.25,1.25L423.98,300.75z"
          />
          <path
            d="M433.55,305.17c0.48,1.09,0.72,2.15,0.72,3.16c0,3.32-2,5.2-6.01,5.62l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.88-0.22-1.79-0.67-2.75L433.55,305.17z M431.05,302.04l1.29-1.29l1.3,1.3l-1.29,1.29L431.05,302.04z"
          />
          <path
            d="M440.15,308.98c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V308.98z"
          />
          <path
            d="M442.44,308.51c-0.71,0.82-1.51,1.23-2.41,1.23h-0.18c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.14
      c0.46,0,0.92-0.27,1.38-0.81c0.19-0.24,0.41-0.63,0.65-1.17c0.75-1.66,1.73-2.49,2.95-2.5c0.95,0,1.69,0.34,2.23,1.02
      c0.54,0.68,0.82,1.47,0.82,2.38c0,0.89-0.19,1.56-0.58,2.01c-0.48,0.56-1.13,0.83-1.98,0.83
      C444.35,309.93,443.35,309.45,442.44,308.51z M445.34,308.39c0.8,0,1.2-0.39,1.2-1.18c0-0.37-0.06-0.69-0.17-0.96
      c-0.28-0.62-0.73-0.94-1.38-0.94c-0.79,0-1.39,0.59-1.81,1.78C443.94,307.96,444.66,308.39,445.34,308.39z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M358.99,162.55c0.48,1.09,0.72,2.15,0.72,3.16c0,3.32-2.01,5.2-6.02,5.62l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.88-0.22-1.79-0.67-2.75L358.99,162.55z"
          />
          <path
            d="M366.09,162.55l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.12,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.14c-0.81,0-1.34-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L366.09,162.55z M363.6,159.43l1.29-1.29l1.3,1.3l-1.29,1.29L363.6,159.43z"
          />
          <path
            d="M368.3,167.13c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.52c1.89,0,4.23-0.72,7.01-2.16l0.64-0.33
      c-0.15-0.04-0.77-0.28-1.86-0.72c-1.12-0.45-1.89-0.68-2.29-0.68c-0.65,0-1.18,0.27-1.6,0.81l-0.24,0.31l-1.32-0.65l0.14-0.24
      c0.72-1.19,1.73-1.78,3.03-1.79c0.73,0,1.6,0.25,2.61,0.74c1.79,0.87,3.17,1.33,4.15,1.37l-0.02,1.5
      c-0.66,0.06-1.87,0.55-3.64,1.49c-2.46,1.29-4.69,1.94-6.71,1.94H368.3z M371.75,156.94l1.25-1.25l1.26,1.26l-1.25,1.25
      L371.75,156.94z"
          />
          <path
            d="M387.05,166.77c0,2.08,1.35,3.12,4.06,3.14c1.02,0,1.93-0.19,2.73-0.56c0.42-0.19,0.79-0.45,1.1-0.77
      c0.31-0.33,0.47-0.7,0.47-1.11c0-0.33-0.22-0.49-0.67-0.49l-0.98-0.01c-1.43-0.01-2.14-0.58-2.14-1.71c0-1.08,0.34-2,1.03-2.75
      c0.89-0.97,2.14-1.45,3.75-1.45h0.18v1.66h-0.19c-0.92,0-1.68,0.21-2.28,0.63c-0.61,0.43-0.92,0.96-0.94,1.58
      c0,0.17,0.05,0.29,0.14,0.37c0.1,0.08,0.25,0.12,0.46,0.12h1.02c1.36-0.01,2.04,0.56,2.04,1.71c0,1.66-0.82,2.87-2.47,3.63
      c-0.97,0.44-2.07,0.66-3.3,0.66c-3.68,0-5.53-1.54-5.53-4.61c0-1.23,0.4-2.75,1.19-4.55l1.37,0.56
      C387.4,164.41,387.05,165.73,387.05,166.77z"
          />
          <path
            d="M402.82,166.37c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V166.37z"
          />
          <path
            d="M403.17,167.13h-0.65c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.65c0.92,0,1.54-0.09,1.87-0.27
      c0.49-0.29,0.73-0.89,0.73-1.8c0-0.68-0.11-1.44-0.32-2.28l1.4-0.35c0.28,0.89,0.42,1.76,0.42,2.6c0,1.4-0.4,2.41-1.2,3.02
      C405.48,166.9,404.52,167.13,403.17,167.13z M402.39,169.85l1.25-1.25l1.26,1.26l-1.25,1.25L402.39,169.85z M405.18,169.85
      l1.25-1.25l1.26,1.26l-1.25,1.25L405.18,169.85z"
          />
          <path
            d="M413.99,162.55c0.48,1.09,0.72,2.15,0.72,3.16c0,3.32-2,5.2-6.01,5.62l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.88-0.22-1.79-0.67-2.75L413.99,162.55z"
          />
          <path
            d="M416.4,165.31c0.72,0.15,1.41,0.22,2.07,0.22c2.12,0,3.18-0.52,3.18-1.56c0-1.2-1.19-2.54-3.57-4.04l0.86-1.31
      c2.84,1.69,4.25,3.46,4.25,5.32c0,2.1-1.54,3.15-4.61,3.15c-0.84,0-1.57-0.07-2.18-0.21V165.31z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M374.73,888.7c-0.66,0-1.18-0.16-1.57-0.48c-0.01,0.77-0.19,1.56-0.57,2.35c-0.84,1.74-2.55,2.6-5.13,2.6
      c-3.47,0-5.2-1.61-5.2-4.82c0-1.17,0.29-2.46,0.87-3.86l1.37,0.56c-0.48,1.21-0.72,2.31-0.72,3.28c0,2.21,1.25,3.32,3.75,3.32
      c2.72,0,4.09-1.27,4.1-3.82c0-1.05-0.26-2.11-0.78-3.18l1.49-0.52l0.52,1.59c0.29,0.91,0.93,1.37,1.91,1.37
      c1.11,0,1.66-0.55,1.66-1.64c0-0.48-0.01-0.8-0.03-0.99l-0.04-0.52l1.42-0.17l0.14,1.99c0.06,0.89,0.51,1.33,1.36,1.33
      c0.85,0,1.27-0.61,1.26-1.81c0-0.59-0.13-1.32-0.38-2.19l1.47-0.4c0.29,0.9,0.43,1.76,0.42,2.58c0,1.3-0.35,2.25-1.04,2.86
      c-0.44,0.38-1.01,0.57-1.72,0.57c-1.06,0-1.76-0.4-2.1-1.2C376.59,888.29,375.78,888.7,374.73,888.7z"
          />
          <path
            d="M388.47,884.12c0.48,1.09,0.72,2.15,0.72,3.16c0,3.32-2,5.2-6.01,5.62l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.88-0.22-1.79-0.67-2.75L388.47,884.12z"
          />
          <path
            d="M395.08,887.94c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V887.94z"
          />
          <path
            d="M398.67,885.5c-1.86,0-2.8-0.78-2.83-2.33c0-0.25,0.02-0.48,0.07-0.71c0.17-0.91,0.5-1.6,0.98-2.1
      c0.48-0.49,1.07-0.74,1.78-0.74c0.48,0,0.9,0.12,1.26,0.35c0.96,0.62,1.54,1.82,1.74,3.59c0.04,0.37,0.06,0.72,0.06,1.06
      c0,1.62-0.39,2.72-1.16,3.3c-0.69,0.52-1.9,0.77-3.63,0.77h-2.17c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h2.26
      c2.18,0,3.3-0.57,3.35-1.7c0-0.05,0-0.1-0.01-0.15C399.85,885.42,399.28,885.5,398.67,885.5z M397.18,877.02l1.25-1.25l1.26,1.26
      l-1.25,1.25L397.18,877.02z M397.26,882.94c0,0.72,0.51,1.07,1.52,1.07c0.48,0,0.97-0.07,1.46-0.22c-0.08-0.66-0.23-1.23-0.44-1.68
      c-0.28-0.62-0.68-0.93-1.19-0.93c-0.6,0-1.01,0.38-1.25,1.15C397.29,882.54,397.26,882.74,397.26,882.94z"
          />
          <path
            d="M418.23,883.02l-0.11,1.5c-0.59,0.05-1.15,0.11-1.68,0.18v0.07c0,1.58,0.8,2.36,2.42,2.35h0.54c0.11,0,0.17,0.21,0.17,0.62
      v0.21c0,0.5-0.06,0.76-0.17,0.76h-0.54c-2.49,0-3.73-1.21-3.74-3.64v-0.1c-3.44,0.87-5.16,2.48-5.16,4.85
      c0,2.11,1.52,3.17,4.56,3.17c1.24,0,2.44-0.27,3.58-0.82l0.31,1.54c-1.14,0.56-2.48,0.83-4.01,0.83c-2.21,0-3.81-0.53-4.79-1.6
      c-0.74-0.8-1.11-1.79-1.11-2.98c0-3.35,2.05-5.47,6.15-6.38l0.09-0.02c-0.15-0.06-0.48-0.19-0.98-0.39
      c-1.12-0.45-1.88-0.68-2.29-0.68c-0.65,0-1.18,0.27-1.6,0.81l-0.24,0.31l-1.32-0.65l0.14-0.24c0.73-1.19,1.74-1.79,3.04-1.79
      c0.72,0,1.59,0.25,2.6,0.74C415.86,882.52,417.25,882.98,418.23,883.02z M412.28,889.6l1.25-1.25l1.26,1.26l-1.25,1.25
      L412.28,889.6z"
          />
          <path
            d="M425.73,887.94c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.04-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.98c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V887.94
      z M419.14,891.42l1.25-1.25l1.26,1.26l-1.25,1.25L419.14,891.42z M421.93,891.42l1.25-1.25l1.26,1.26l-1.25,1.25L421.93,891.42z"
          />
          <path
            d="M425.86,888.7h-0.43c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.45c1.52,0,2.29-0.59,2.29-1.78l0.04-9
      h1.49v9c0,1.19,0.62,1.78,1.86,1.78h0.15c0.14,0,0.21,0.22,0.21,0.66v0.16c0,0.5-0.07,0.76-0.21,0.76h-0.13
      c-1.23,0-2.14-0.41-2.72-1.22C428.31,888.29,427.31,888.7,425.86,888.7z"
          />
          <path
            d="M431.6,888.7c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.52c1.89,0,4.23-0.72,7.01-2.16l0.64-0.33
      c-0.15-0.04-0.77-0.28-1.86-0.72c-1.12-0.45-1.89-0.68-2.29-0.68c-0.65,0-1.18,0.27-1.6,0.81l-0.24,0.31l-1.32-0.65l0.14-0.24
      c0.72-1.19,1.73-1.78,3.03-1.79c0.73,0,1.6,0.25,2.61,0.74c1.79,0.87,3.17,1.33,4.15,1.37l-0.02,1.5
      c-0.66,0.06-1.87,0.55-3.64,1.49c-2.46,1.29-4.69,1.94-6.71,1.94H431.6z M435.04,878.51l1.25-1.25l1.26,1.26l-1.25,1.25
      L435.04,878.51z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M289.86,260.79c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C286.11,259.73,287.36,260.8,289.86,260.79z M288.6,252.48l1.25-1.25l1.26,1.26l-1.25,1.25
      L288.6,252.48z"
          />
          <path
            d="M302.08,256.47c1.32-0.42,1.98-1.61,1.98-3.58v-6.86h1.49v7.64c0,2.09,0.6,3.14,1.81,3.14h0.21c0.11,0,0.17,0.22,0.17,0.66
      v0.16c0,0.5-0.06,0.76-0.17,0.76h-0.34c-1.39,0-2.27-0.65-2.65-1.94c-0.93,1.28-2.53,1.92-4.8,1.92c-0.79,0-1.43-0.05-1.92-0.14
      v-1.56c0.96,0.13,1.9,0.16,2.81,0.1c-0.82-2.81-1.98-5.95-3.48-9.42l1.42-0.81C300.14,250.23,301.29,253.53,302.08,256.47z"
          />
          <path
            d="M313.89,257.63c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.04-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.98c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V257.63
      z M307.3,261.11l1.25-1.25l1.26,1.26l-1.25,1.25L307.3,261.11z M310.09,261.11l1.25-1.25l1.26,1.26l-1.25,1.25L310.09,261.11z"
          />
          <path
            d="M318.81,252.72c0.75,0.81,1.11,1.7,1.09,2.66c-0.03,2-1.73,3.01-5.09,3.01h-1.23c-0.33,0-0.5-0.25-0.5-0.76v-0.16
      c0-0.44,0.17-0.66,0.5-0.66h1.22c2.37,0,3.55-0.55,3.56-1.64c0-0.56-0.3-1.12-0.89-1.68c-0.88-0.82-1.66-1.5-2.35-2.04
      c-0.65-0.51-0.98-1.05-0.98-1.61c0-0.74,0.4-1.27,1.2-1.57l5.96-2.26v1.56l-5.77,2.15C317.03,250.97,318.12,251.97,318.81,252.72z
       M321.24,244.76l-6.72,2.59v-1.1l6.72-2.59V244.76z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M201.29,172.64l0.02-10.15h1.31l-0.01,7.91c0,1.07,0.58,1.6,1.73,1.6h0.15c0.1,0,0.15,0.18,0.15,0.55v0.18
      c0,0.45-0.05,0.67-0.15,0.67h-0.19c-0.78,0-1.37-0.19-1.75-0.57c-0.13,3.01-1.64,4.52-4.55,4.52c-2.94,0-4.4-1.41-4.39-4.23
      c0-0.53,0.05-1.04,0.15-1.55c0.11-0.53,0.27-1.05,0.48-1.56l1.21,0.49c-0.34,0.86-0.51,1.73-0.51,2.6c0,1.93,1.02,2.89,3.07,2.89
      C200.19,176,201.29,174.88,201.29,172.64z"
          />
          <path
            d="M210.08,172.73c0,0.45-0.05,0.67-0.15,0.67h-0.08c-1,0-1.69-0.36-2.07-1.07c-0.5,0.71-1.38,1.07-2.63,1.07h-0.79
      c-0.29,0-0.43-0.22-0.43-0.67v-0.14c0-0.39,0.14-0.58,0.43-0.58h0.75c1.17,0,1.82-0.33,1.94-1c0.03-0.18,0.05-0.39,0.05-0.63
      c0-0.25-0.01-0.49-0.02-0.72l-0.04-0.62l1.25-0.15l0.12,1.75c0.07,0.91,0.55,1.37,1.46,1.37h0.06c0.1,0,0.15,0.22,0.15,0.65V172.73
      z M204.25,175.8l1.11-1.1l1.11,1.11l-1.1,1.1L204.25,175.8z M206.72,175.8l1.1-1.1l1.11,1.11l-1.1,1.1L206.72,175.8z"
          />
          <path
            d="M210.39,173.4h-0.58c-0.29,0-0.44-0.22-0.44-0.67v-0.14c0-0.39,0.15-0.58,0.44-0.58h0.58c0.81,0,1.36-0.08,1.65-0.24
      c0.43-0.25,0.65-0.78,0.65-1.59c0-0.6-0.09-1.27-0.28-2.01l1.24-0.31c0.25,0.79,0.37,1.56,0.37,2.3c0,1.24-0.35,2.13-1.06,2.67
      C212.43,173.2,211.58,173.4,210.39,173.4z M210.79,175.8l1.1-1.1l1.11,1.11l-1.11,1.1L210.79,175.8z"
          />
          <path
            d="M215.54,171.79c0.64,0.13,1.25,0.2,1.83,0.2c1.87,0,2.81-0.46,2.81-1.37c0-1.06-1.05-2.25-3.15-3.57l0.76-1.15
      c2.51,1.49,3.76,3.06,3.76,4.7c0,1.85-1.36,2.78-4.08,2.79c-0.74,0-1.39-0.06-1.93-0.18V171.79z"
          />
          <path
            d="M227.22,169.36c0.43,0.97,0.64,1.9,0.64,2.79c0,2.94-1.77,4.59-5.32,4.97l-0.32-1.29c2.87-0.29,4.3-1.48,4.3-3.58
      c0-0.77-0.2-1.58-0.59-2.43L227.22,169.36z"
          />
          <path d="M229.81,162.48h1.31v10.91h-1.31V162.48z" />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M103.76,207.11c0.11,0,0.16,0.2,0.16,0.59v0.15c0,0.45-0.05,0.67-0.16,0.67h-1.09h-0.19c0.29,0.22,0.44,0.51,0.44,0.87
      c0,0.78-0.46,1.47-1.39,2.07c-1.06,0.69-2.32,1.04-3.77,1.04c-3.29,0-4.93-1.32-4.93-3.97c0-1.09,0.26-2.19,0.77-3.32l1.22,0.5
      c-0.43,1.1-0.65,2.01-0.65,2.73c0,1.81,1.19,2.71,3.58,2.71c0.9,0,1.71-0.16,2.42-0.49c0.59-0.27,1.01-0.59,1.26-0.97
      c0.12-0.18,0.18-0.35,0.18-0.51c0-0.44-0.34-0.66-1.01-0.66h-1.17c-0.3-0.03-0.5-0.27-0.61-0.72c-0.05-0.21-0.08-0.37-0.08-0.48
      c0-0.12,0.03-0.19,0.08-0.21H103.76z"
          />
          <path
            d="M107.14,205.67c-1.66,0-2.5-0.69-2.52-2.08c0-0.22,0.02-0.43,0.06-0.64c0.15-0.81,0.44-1.43,0.87-1.87
      c0.43-0.44,0.96-0.66,1.59-0.66c0.43,0,0.81,0.1,1.13,0.31c0.85,0.55,1.37,1.62,1.55,3.2c0.04,0.33,0.05,0.65,0.05,0.94
      c0,1.45-0.35,2.43-1.04,2.94c-0.61,0.46-1.69,0.69-3.23,0.69h-1.93c-0.3,0-0.44-0.22-0.44-0.67v-0.15c0-0.39,0.15-0.59,0.44-0.59
      h2.02c1.95,0,2.94-0.51,2.99-1.52c0-0.05,0-0.09-0.01-0.14C108.19,205.6,107.68,205.67,107.14,205.67z M104.58,198.13l1.12-1.12
      l1.12,1.12l-1.12,1.12L104.58,198.13z M105.88,203.39c0,0.64,0.45,0.96,1.36,0.95c0.43,0,0.86-0.07,1.3-0.2
      c-0.07-0.59-0.2-1.09-0.39-1.5c-0.25-0.55-0.61-0.83-1.07-0.83c-0.53,0-0.9,0.34-1.11,1.03
      C105.91,203.03,105.88,203.21,105.88,203.39z M107.08,198.13l1.12-1.12l1.12,1.12l-1.12,1.12L107.08,198.13z"
          />
          <path
            d="M115.62,204.44l0.44,1.48c0.23,0.79,0.72,1.19,1.46,1.19h0.21c0.1,0,0.15,0.18,0.15,0.55v0.18c0,0.45-0.05,0.67-0.15,0.67
      h-0.13c-0.73,0-1.19-0.14-1.4-0.41c-0.29,2.43-2.06,3.81-5.3,4.16l-0.32-1.3c2.9-0.29,4.34-1.5,4.34-3.63
      c0-0.77-0.2-1.58-0.61-2.45L115.62,204.44z"
          />
          <path
            d="M124.06,205.99c0.03-0.15,0.05-0.33,0.05-0.54c0-0.23-0.01-0.47-0.03-0.71l-0.05-0.46l1.27-0.15l0.12,1.77
      c0.06,0.81,0.46,1.21,1.2,1.21c0.76,0,1.14-0.55,1.14-1.64c0-0.53-0.11-1.18-0.34-1.96l1.31-0.35c0.26,0.81,0.38,1.56,0.38,2.25
      c0,0.02,0,0.03,0,0.05c-0.01,1.16-0.32,2.01-0.94,2.55c-0.38,0.34-0.89,0.51-1.53,0.51c-0.95,0-1.57-0.36-1.87-1.07
      c-0.52,0.72-1.24,1.08-2.19,1.08c-1.09,0-1.79-0.37-2.1-1.08c-0.41,0.72-1.23,1.08-2.48,1.08h-0.43c-0.3,0-0.44-0.22-0.44-0.67
      v-0.15c0-0.39,0.15-0.59,0.44-0.59h0.44c1.05,0,1.65-0.38,1.81-1.13c0.03-0.15,0.05-0.33,0.05-0.54c0-0.22-0.01-0.46-0.03-0.71
      l-0.05-0.46l1.27-0.15l0.12,1.77c0.06,0.81,0.53,1.22,1.41,1.22C123.43,207.11,123.92,206.74,124.06,205.99z M122.19,201.31
      l1.08-1.09l1.1,1.1l-1.09,1.09L122.19,201.31z M123.41,199.25l1.09-1.09l1.1,1.1l-1.09,1.09L123.41,199.25z M124.67,201.31
      l1.09-1.09l1.1,1.1l-1.09,1.09L124.67,201.31z"
          />
          <path
            d="M139.69,210.67c2.43-0.01,3.65-1.14,3.64-3.4c0-0.98-0.23-1.94-0.69-2.89l1.33-0.47c0.5,1.25,0.75,2.37,0.75,3.37
      c-0.01,0.95-0.18,1.77-0.52,2.46c-0.76,1.52-2.29,2.28-4.58,2.28c-3.08,0-4.63-1.41-4.63-4.24c0-1.09,0.26-2.25,0.77-3.5l1.22,0.5
      c-0.43,1.08-0.64,2.09-0.64,3.01C136.35,209.72,137.46,210.67,139.69,210.67z M138.57,203.25l1.12-1.12l1.12,1.12l-1.12,1.12
      L138.57,203.25z"
          />
          <path
            d="M150.02,207.85c0,0.45-0.05,0.67-0.15,0.67h-0.16c-1.98,0-2.97-1.11-2.97-3.33v-7.7h1.33v7.68c0,1.29,0.55,1.93,1.66,1.93
      h0.14c0.1,0,0.15,0.2,0.15,0.59V207.85z"
          />
          <path
            d="M157.04,204.9c-0.12-0.03-0.67-0.25-1.66-0.64c-1-0.4-1.68-0.61-2.05-0.61c-0.58,0-1.05,0.24-1.43,0.72l-0.21,0.28
      l-1.18-0.58l0.12-0.21c0.64-1.06,1.55-1.59,2.71-1.59c0.65,0,1.43,0.22,2.33,0.66c1.59,0.78,2.83,1.18,3.7,1.22l-0.02,1.33
      c-0.42,0.03-0.95,0.21-1.59,0.53c0.02,0.75,0.73,1.12,2.13,1.12h0.33c0.11,0,0.16,0.18,0.16,0.55v0.18c0,0.45-0.05,0.67-0.16,0.67
      h-0.45c-1.87,0-2.88-0.68-3.04-2.05c-0.2,0.1-0.41,0.2-0.63,0.32c-2.19,1.15-4.19,1.73-5.99,1.73h-0.37c-0.3,0-0.44-0.22-0.44-0.67
      v-0.15c0-0.39,0.15-0.59,0.44-0.59h0.46c1.69,0,3.77-0.64,6.26-1.92L157.04,204.9z M154.12,210.95l1.12-1.12l1.12,1.12l-1.12,1.12
      L154.12,210.95z"
          />
          <path
            d="M160.69,208.52h-0.58c-0.3,0-0.44-0.22-0.44-0.67v-0.15c0-0.39,0.15-0.59,0.44-0.59h0.58c0.82,0,1.37-0.08,1.66-0.25
      c0.43-0.26,0.65-0.79,0.65-1.6c0-0.61-0.09-1.29-0.28-2.03l1.25-0.31c0.25,0.8,0.38,1.57,0.38,2.32c0,1.25-0.36,2.15-1.07,2.69
      C162.76,208.33,161.89,208.52,160.69,208.52z M159.99,210.95l1.12-1.12l1.12,1.12l-1.12,1.12L159.99,210.95z M162.49,210.95
      l1.12-1.12l1.12,1.12l-1.12,1.12L162.49,210.95z"
          />
          <path
            d="M169.91,207.85c0,0.45-0.05,0.67-0.15,0.67h-0.16c-1.98,0-2.97-1.11-2.97-3.33v-7.7h1.33v7.68c0,1.29,0.55,1.93,1.66,1.93
      h0.14c0.1,0,0.15,0.2,0.15,0.59V207.85z"
          />
          <path
            d="M170.22,208.52h-0.58c-0.3,0-0.44-0.22-0.44-0.67v-0.15c0-0.39,0.15-0.59,0.44-0.59h0.58c0.82,0,1.37-0.08,1.66-0.25
      c0.43-0.26,0.65-0.79,0.65-1.6c0-0.61-0.09-1.29-0.28-2.03l1.25-0.31c0.25,0.8,0.38,1.57,0.38,2.32c0,1.25-0.36,2.15-1.07,2.69
      C172.28,208.33,171.42,208.52,170.22,208.52z M170.63,210.95l1.12-1.12l1.12,1.12l-1.12,1.12L170.63,210.95z"
          />
          <path
            d="M179.6,204.44c0.43,0.98,0.64,1.92,0.64,2.82c0,2.96-1.79,4.64-5.37,5.01l-0.32-1.3c2.9-0.29,4.34-1.5,4.34-3.62
      c0-0.78-0.2-1.6-0.6-2.45L179.6,204.44z"
          />
          <path
            d="M181.75,206.91c0.64,0.13,1.26,0.2,1.85,0.2c1.89,0,2.84-0.46,2.84-1.39c0-1.07-1.06-2.27-3.18-3.6l0.77-1.17
      c2.53,1.51,3.79,3.09,3.79,4.75c0,1.87-1.37,2.81-4.12,2.81c-0.75,0-1.4-0.06-1.95-0.18V206.91z M182.83,198.51l1.12-1.12
      l1.12,1.12l-1.12,1.12L182.83,198.51z"
          />
          <path
            d="M190.54,197.11c-0.57-0.08-1.09,0.16-1.56,0.72l-0.77-0.81c0.6-0.87,1.34-1.23,2.21-1.1l1.14,0.18
      c0.5,0.08,1.06-0.04,1.68-0.35l0.51,1.05c-0.66,0.41-1.37,0.56-2.12,0.46L190.54,197.11z M190.51,198.61h1.33v9.91h-1.33V198.61z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M49.78,190.99c0.03,0.09-0.11,0.18-0.43,0.3l-0.12,0.04c-0.36,0.13-0.55,0.15-0.58,0.06l-0.31-0.87l-0.05-0.15
      c-0.1,0.3-0.29,0.5-0.57,0.6c-0.62,0.22-1.31,0.05-2.05-0.52c-0.85-0.65-1.49-1.56-1.9-2.72c-0.93-2.62-0.34-4.31,1.77-5.06
      c0.87-0.31,1.82-0.42,2.87-0.33l-0.05,1.12c-1-0.04-1.79,0.05-2.36,0.25c-1.44,0.51-1.83,1.72-1.15,3.63
      c0.26,0.72,0.62,1.32,1.08,1.79c0.38,0.39,0.75,0.64,1.13,0.73c0.18,0.04,0.33,0.04,0.46-0.01c0.35-0.12,0.43-0.46,0.24-0.99
      l-0.33-0.94c-0.06-0.25,0.07-0.47,0.4-0.69c0.16-0.1,0.28-0.17,0.36-0.2c0.09-0.03,0.16-0.03,0.19,0.01L49.78,190.99z"
          />
          <path
            d="M46.97,192.79l1.21,0.57l-0.58,1.22l-1.21-0.57L46.97,192.79z M48.79,191.78l-0.17-0.47c-0.08-0.24,0.05-0.42,0.41-0.55
      l0.12-0.04c0.31-0.11,0.51-0.05,0.6,0.19l0.17,0.47c0.23,0.65,0.46,1.07,0.67,1.26c0.33,0.27,0.82,0.29,1.46,0.06
      c0.49-0.17,1-0.44,1.54-0.8l0.61,0.91c-0.56,0.43-1.15,0.75-1.75,0.96c-1,0.36-1.82,0.33-2.45-0.09
      C49.53,193.37,49.13,192.73,48.79,191.78z"
          />
          <path
            d="M54.71,198.09l-1.06,0.77c-0.57,0.41-0.74,0.91-0.53,1.5l0.06,0.17c0.03,0.08-0.1,0.17-0.4,0.28l-0.15,0.05
      c-0.36,0.13-0.55,0.15-0.58,0.07l-0.04-0.1c-0.21-0.58-0.23-0.99-0.07-1.23c-2.02,0.46-3.63-0.56-4.83-3.04l0.95-0.63
      c1.06,2.23,2.43,3.04,4.13,2.43c0.61-0.22,1.21-0.61,1.78-1.18L54.71,198.09z"
          />
          <path
            d="M57.48,204.89c0.24-0.65,0.27-1.23,0.09-1.73c-0.09-0.26-0.21-0.48-0.36-0.67c-0.15-0.18-0.32-0.32-0.53-0.42
      c-0.19-0.09-0.39-0.14-0.59-0.16c-0.2-0.01-0.41,0.02-0.62,0.1c-0.55,0.2-0.87,0.67-0.95,1.41c-0.01,0.11-0.01,0.17,0,0.18
      l1.63,2.43l-1.13,0.4c-1.29-1.73-2.23-3.41-2.81-5.04l-0.2-0.56c-0.08-0.24,0.05-0.42,0.41-0.55l0.12-0.04
      c0.31-0.11,0.51-0.05,0.6,0.19l0.59,1.67l0.02,0.04l0.02-0.04c0.07-0.14,0.16-0.28,0.26-0.4c0.27-0.35,0.64-0.61,1.13-0.78
      c0.67-0.23,1.3-0.25,1.88-0.05c0.31,0.11,0.59,0.28,0.85,0.51c0.34,0.3,0.59,0.71,0.77,1.21c0.29,0.84,0.26,1.63-0.11,2.37
      L57.48,204.89z M60.43,200.8l1.21,0.57l-0.58,1.22l-1.21-0.57L60.43,200.8z"
          />
          <path
            d="M55.41,215.79c0.7,1.94,1.95,2.58,3.75,1.94c0.78-0.28,1.49-0.74,2.11-1.37l0.75,0.92c-0.85,0.75-1.68,1.27-2.47,1.56
      c-0.76,0.27-1.46,0.36-2.11,0.28c-1.43-0.17-2.47-1.18-3.12-3c-0.88-2.46-0.19-4.09,2.07-4.9c0.87-0.31,1.87-0.44,3.01-0.38
      l-0.05,1.11c-0.99-0.03-1.85,0.08-2.58,0.35C55.22,212.86,54.78,214.02,55.41,215.79z M61.01,212.79l1.21,0.57l-0.58,1.22
      l-1.21-0.57L61.01,212.79z"
          />
          <path
            d="M60.6,223.24c-0.36,0.13-0.55,0.16-0.58,0.07l-0.05-0.13c-0.56-1.58,0.04-2.69,1.81-3.32l6.14-2.19l0.38,1.06l-6.13,2.18
      c-1.03,0.37-1.38,0.99-1.07,1.88l0.04,0.11c0.03,0.08-0.11,0.18-0.43,0.29L60.6,223.24z"
          />
          <path
            d="M59.29,227.39l1.21,0.57l-0.58,1.22l-1.21-0.57L59.29,227.39z M64.95,227.99c-0.01-0.11,0-0.61,0.04-1.5
      c0.04-0.91,0-1.52-0.1-1.81c-0.16-0.46-0.49-0.77-0.98-0.93l-0.28-0.09l0.13-1.11l0.21,0.04c1.03,0.21,1.71,0.78,2.04,1.71
      c0.18,0.52,0.23,1.2,0.14,2.05c-0.17,1.49-0.14,2.59,0.08,3.3l-1.07,0.37c-0.14-0.33-0.43-0.7-0.87-1.12
      c-0.59,0.23-0.69,0.9-0.29,2.02l0.09,0.26c0.03,0.09-0.1,0.18-0.39,0.29l-0.15,0.05c-0.36,0.13-0.55,0.15-0.58,0.06l-0.13-0.36
      c-0.53-1.49-0.27-2.49,0.77-3.01c-0.13-0.13-0.28-0.27-0.44-0.41c-1.54-1.42-2.57-2.85-3.08-4.29l-0.1-0.29
      c-0.08-0.24,0.05-0.42,0.41-0.55l0.12-0.04c0.31-0.11,0.51-0.05,0.6,0.19l0.13,0.37c0.48,1.35,1.58,2.83,3.31,4.45L64.95,227.99z"
          />
          <path
            d="M60.96,232.08l1.21,0.57l-0.58,1.22l-1.21-0.57L60.96,232.08z M61.67,234.07l1.21,0.57l-0.58,1.22l-1.21-0.57L61.67,234.07
      z M63.1,231.94l-0.17-0.46c-0.08-0.24,0.05-0.42,0.41-0.55l0.12-0.04c0.31-0.11,0.51-0.05,0.6,0.19l0.17,0.46
      c0.23,0.65,0.46,1.07,0.67,1.26c0.33,0.27,0.82,0.29,1.46,0.06c0.49-0.17,1-0.44,1.54-0.8l0.61,0.91
      c-0.57,0.43-1.15,0.75-1.75,0.96c-1,0.36-1.82,0.33-2.45-0.09C63.84,233.53,63.44,232.9,63.1,231.94z"
          />
          <path
            d="M66.25,239.1c-0.36,0.13-0.55,0.16-0.58,0.07l-0.05-0.13c-0.56-1.58,0.04-2.69,1.81-3.32l6.14-2.19l0.38,1.06l-6.13,2.18
      c-1.03,0.37-1.38,0.99-1.07,1.88l0.04,0.11c0.03,0.08-0.11,0.18-0.43,0.29L66.25,239.1z"
          />
          <path
            d="M63.98,240.56l1.21,0.57l-0.58,1.22l-1.21-0.57L63.98,240.56z M65.81,239.55l-0.17-0.46c-0.08-0.24,0.05-0.42,0.41-0.55
      l0.12-0.04c0.31-0.11,0.51-0.05,0.6,0.19l0.17,0.46c0.23,0.65,0.46,1.07,0.67,1.26c0.33,0.27,0.82,0.29,1.46,0.06
      c0.49-0.17,1-0.44,1.54-0.8l0.61,0.91c-0.56,0.43-1.15,0.75-1.75,0.96c-1,0.36-1.82,0.32-2.45-0.09
      C66.55,241.14,66.15,240.51,65.81,239.55z"
          />
          <path
            d="M71.72,245.87c-0.66,0.62-1.35,1.06-2.07,1.32c-2.37,0.84-4.21-0.11-5.53-2.86l0.95-0.63c1.06,2.23,2.43,3.04,4.12,2.43
      c0.62-0.22,1.22-0.61,1.79-1.17L71.72,245.87z"
          />
          <path
            d="M70.37,248.29c0.08,0.55,0.2,1.06,0.37,1.53c0.54,1.51,1.18,2.13,1.91,1.87c0.85-0.3,1.51-1.49,1.97-3.56l1.15,0.28
      c-0.48,2.45-1.39,3.91-2.71,4.38c-1.49,0.53-2.63-0.3-3.42-2.49c-0.21-0.6-0.35-1.13-0.41-1.61L70.37,248.29z M77.38,246.76
      l1.21,0.57l-0.58,1.22l-1.21-0.57L77.38,246.76z"
          />
          <path
            d="M79.48,252.92l0.38,1.06l-7.9,2.82l-0.38-1.06L79.48,252.92z M80.69,252.51c-0.1-0.47-0.44-0.82-1.02-1.04l0.43-0.85
      c0.87,0.23,1.37,0.72,1.5,1.45l0.18,0.96c0.08,0.42,0.33,0.83,0.76,1.24l-0.69,0.7c-0.51-0.41-0.84-0.93-0.97-1.56L80.69,252.51z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M541.5,365.72c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C537.75,364.65,539.01,365.73,541.5,365.72z M540.24,357.41l1.25-1.25l1.26,1.26l-1.25,1.25
      L540.24,357.41z"
          />
          <path
            d="M553.08,362.56c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V362.56z"
          />
          <path
            d="M559.24,362.56c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.04-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.98c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V362.56
      z M554.77,355.06l1.25-1.25l1.26,1.26l-1.25,1.25L554.77,355.06z"
          />
          <path
            d="M564.54,363.5c-1.05,0-2.06-0.47-3.01-1.42c-0.71,0.82-1.51,1.23-2.41,1.23h-0.18c-0.33,0-0.49-0.25-0.49-0.76v-0.16
      c0-0.44,0.16-0.66,0.49-0.66h0.14c0.53,0,0.99-0.27,1.38-0.81c0.21-0.29,0.42-0.68,0.64-1.18c0.74-1.66,1.73-2.49,2.95-2.49
      c0.93,0,1.66,0.34,2.2,1.02c0.38,0.49,0.65,1.11,0.81,1.84c0.23,1.08,0.68,1.62,1.36,1.62h0.13c0.11,0,0.17,0.22,0.17,0.66v0.16
      c0,0.5-0.06,0.76-0.17,0.76h-0.14c-0.66,0-1.2-0.32-1.62-0.96C566.3,363.12,565.55,363.5,564.54,363.5z M564.44,361.96
      c0.83,0.01,1.24-0.39,1.22-1.19c0-0.33-0.07-0.65-0.2-0.95c-0.28-0.62-0.74-0.93-1.39-0.94c-0.77-0.01-1.37,0.58-1.8,1.78
      C563.01,361.53,563.74,361.96,564.44,361.96z"
          />
          <path
            d="M575.67,360.47c0.03-0.17,0.05-0.37,0.05-0.6c0-0.26-0.01-0.52-0.04-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.51,1.36,1.35,1.36c0.85,0,1.28-0.61,1.28-1.84c0-0.59-0.13-1.32-0.38-2.19l1.47-0.4c0.29,0.91,0.43,1.75,0.42,2.53
      c0,0.02,0,0.03,0,0.05c-0.01,1.3-0.36,2.25-1.05,2.86c-0.43,0.38-1,0.57-1.71,0.57c-1.06,0-1.76-0.4-2.1-1.2
      c-0.58,0.81-1.4,1.21-2.45,1.21c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76
      v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.5c1.17,0,1.85-0.42,2.03-1.26c0.03-0.17,0.05-0.37,0.05-0.6c0-0.25-0.01-0.51-0.03-0.8
      l-0.05-0.52l1.42-0.17l0.14,1.99c0.06,0.91,0.59,1.37,1.58,1.37C574.96,361.73,575.51,361.31,575.67,360.47z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M358.46,326.9c0.42,0.95,0.63,1.86,0.63,2.74c0,2.88-1.74,4.51-5.22,4.88l-0.31-1.27c2.82-0.28,4.23-1.46,4.22-3.52
      c0-0.76-0.19-1.56-0.58-2.39L358.46,326.9z M356.3,324.19l1.12-1.12l1.13,1.13l-1.12,1.12L356.3,324.19z"
          />
          <path
            d="M364.62,326.9l0.42,1.44c0.22,0.77,0.7,1.16,1.42,1.16h0.21c0.1,0,0.15,0.18,0.15,0.54v0.18c0,0.44-0.05,0.66-0.15,0.66
      h-0.13c-0.71,0-1.16-0.13-1.36-0.4c-0.28,2.36-2,3.71-5.15,4.05l-0.31-1.27c2.82-0.28,4.23-1.46,4.22-3.53
      c0-0.75-0.2-1.54-0.59-2.38L364.62,326.9z"
          />
          <path
            d="M372.15,330.21c0,0.44-0.05,0.66-0.15,0.66h-0.07c-0.98,0-1.66-0.35-2.04-1.05c-0.49,0.7-1.35,1.05-2.58,1.05h-0.78
      c-0.28,0-0.43-0.22-0.43-0.66v-0.14c0-0.38,0.14-0.57,0.43-0.57h0.74c1.15,0,1.78-0.33,1.91-0.98c0.03-0.17,0.04-0.38,0.04-0.62
      c0-0.25-0.01-0.48-0.02-0.71l-0.04-0.6l1.22-0.15l0.12,1.72c0.06,0.9,0.54,1.34,1.43,1.34H372c0.1,0,0.15,0.21,0.15,0.64V330.21z
       M367.79,333.23l1.08-1.08l1.09,1.09l-1.08,1.08L367.79,333.23z"
          />
          <path
            d="M371.89,330.87c-0.29,0-0.43-0.22-0.43-0.66v-0.14c0-0.38,0.14-0.57,0.43-0.57h0.36c1.33,0,1.99-0.62,1.99-1.87v-7.48h1.3
      v7.52c0,2.13-1.11,3.2-3.33,3.2H371.89z"
          />
          <path d="M377.87,320.15h1.29v10.71h-1.29V320.15z" />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M305.88,322.81c-0.01,0.74-0.18,1.47-0.53,2.2c-0.8,1.63-2.4,2.44-4.81,2.44c-3.25,0-4.88-1.51-4.88-4.52
      c0-1.1,0.27-2.31,0.81-3.62l1.28,0.52c-0.45,1.14-0.68,2.17-0.68,3.08c0,2.07,1.17,3.11,3.51,3.11c2.55,0,3.83-1.2,3.85-3.59
      c0-0.99-0.24-1.98-0.73-2.98l1.39-0.48l0.59,1.84c0.21,0.64,0.73,0.97,1.56,0.97h0.15c0.11,0,0.16,0.19,0.16,0.58v0.19
      c0,0.47-0.05,0.71-0.16,0.71h-0.12C306.66,323.26,306.2,323.11,305.88,322.81z M299.43,318.3l1.17-1.17l1.18,1.18l-1.17,1.17
      L299.43,318.3z"
          />
          <path
            d="M307.88,323.26h-0.61c-0.31,0-0.47-0.24-0.47-0.71v-0.15c0-0.41,0.16-0.62,0.47-0.62h0.61c0.86,0,1.44-0.09,1.75-0.26
      c0.46-0.27,0.69-0.83,0.69-1.68c0-0.64-0.1-1.35-0.3-2.14l1.31-0.33c0.26,0.84,0.4,1.65,0.4,2.44c0,1.32-0.38,2.26-1.13,2.83
      C310.05,323.05,309.14,323.26,307.88,323.26z M307.15,325.81l1.17-1.17l1.18,1.18l-1.17,1.17L307.15,325.81z M309.77,325.81
      l1.17-1.17l1.18,1.18l-1.17,1.17L309.77,325.81z"
          />
          <path
            d="M316.67,323.28c-1.96,0-2.94-0.81-2.94-2.42c0-0.65,0.14-1.27,0.42-1.85c0.5-1.06,1.27-1.59,2.29-1.59
      c1.1,0,1.88,0.62,2.35,1.85c0.33,0.85,0.49,1.8,0.48,2.86c-0.02,3.01-1.87,4.7-5.55,5.08l-0.34-1.37c2.54-0.26,4.03-1.15,4.47-2.68
      C317.23,323.24,316.83,323.28,316.67,323.28z M317.91,321.63c-0.12-1.79-0.64-2.68-1.56-2.68c-0.52,0-0.88,0.32-1.1,0.97
      c-0.1,0.29-0.15,0.56-0.15,0.82c0,0.74,0.53,1.11,1.59,1.1C317.07,321.84,317.48,321.77,317.91,321.63z"
          />
          <path
            d="M325.28,318.97l0.46,1.56c0.24,0.83,0.75,1.25,1.53,1.25h0.23c0.11,0,0.16,0.19,0.16,0.58v0.19c0,0.47-0.05,0.71-0.16,0.71
      h-0.14c-0.76,0-1.25-0.14-1.47-0.43c-0.31,2.55-2.16,4.01-5.57,4.38l-0.34-1.37c3.05-0.31,4.57-1.58,4.56-3.81
      c0-0.81-0.21-1.66-0.64-2.57L325.28,318.97z M322.94,316.04l1.21-1.21l1.22,1.22l-1.21,1.21L322.94,316.04z"
          />
          <path
            d="M331,320.26c-1.75,0-2.63-0.73-2.65-2.18c0-0.23,0.02-0.45,0.06-0.67c0.16-0.85,0.47-1.5,0.92-1.97
      c0.45-0.46,1.01-0.69,1.67-0.69c0.45,0,0.85,0.11,1.19,0.33c0.9,0.58,1.44,1.7,1.63,3.37c0.04,0.35,0.06,0.68,0.06,0.99
      c0,1.52-0.36,2.55-1.09,3.1c-0.65,0.48-1.78,0.73-3.4,0.73h-2.03c-0.31,0-0.47-0.24-0.47-0.71v-0.15c0-0.41,0.16-0.62,0.47-0.62
      h2.12c2.05,0,3.1-0.53,3.14-1.6c0-0.05,0-0.1-0.01-0.15C332.11,320.19,331.58,320.26,331,320.26z M328.32,312.33l1.17-1.17
      l1.18,1.18l-1.17,1.17L328.32,312.33z M329.68,317.86c0,0.67,0.48,1,1.43,1c0.45,0,0.91-0.07,1.37-0.21
      c-0.08-0.62-0.21-1.15-0.41-1.58c-0.26-0.58-0.64-0.87-1.12-0.87c-0.56,0-0.95,0.36-1.17,1.08
      C329.71,317.48,329.68,317.68,329.68,317.86z M330.94,312.33l1.17-1.17l1.18,1.18l-1.17,1.17L330.94,312.33z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M215.83,290.92c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C212.08,289.85,213.34,290.93,215.83,290.92z M214.58,282.61l1.25-1.25l1.26,1.26l-1.25,1.25
      L214.58,282.61z"
          />
          <path
            d="M227.41,287.76c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V287.76z"
          />
          <path
            d="M235.27,284.45c-0.14-0.03-0.76-0.27-1.86-0.72c-1.12-0.45-1.89-0.68-2.29-0.68c-0.65,0-1.18,0.27-1.6,0.81l-0.24,0.31
      l-1.32-0.65l0.14-0.24c0.72-1.19,1.73-1.78,3.03-1.79c0.73,0,1.6,0.25,2.61,0.74c1.79,0.87,3.17,1.33,4.15,1.37l-0.02,1.5
      c-0.47,0.03-1.06,0.23-1.78,0.59c0.02,0.84,0.82,1.25,2.39,1.25h0.37c0.12,0,0.18,0.21,0.18,0.62v0.21c0,0.5-0.06,0.76-0.18,0.76
      h-0.51c-2.09,0-3.23-0.77-3.41-2.3c-0.22,0.11-0.46,0.23-0.71,0.36c-2.46,1.29-4.69,1.94-6.71,1.94h-0.41
      c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.52c1.89,0,4.23-0.72,7.01-2.16L235.27,284.45z M232,291.24
      l1.25-1.25l1.26,1.26l-1.25,1.25L232,291.24z"
          />
          <path
            d="M239.37,288.52h-0.65c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.65c0.92,0,1.54-0.09,1.87-0.27
      c0.49-0.29,0.73-0.89,0.73-1.8c0-0.68-0.11-1.44-0.32-2.28l1.4-0.35c0.28,0.89,0.42,1.76,0.42,2.6c0,1.4-0.4,2.41-1.2,3.02
      C241.68,288.3,240.72,288.52,239.37,288.52z M240.32,279.53l1.25-1.25l1.26,1.26l-1.25,1.25L240.32,279.53z"
          />
          <path
            d="M249.88,283.95c0.48,1.09,0.72,2.15,0.72,3.16c0,3.32-2,5.2-6.01,5.62l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.88-0.22-1.79-0.67-2.75L249.88,283.95z M247.39,280.82l1.29-1.29l1.3,1.3l-1.29,1.29L247.39,280.82z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M130.44,350.53c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.59,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.46,0-5.19-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C126.7,349.46,127.95,350.53,130.44,350.53z M129.19,342.22l1.25-1.25l1.26,1.26l-1.25,1.25
      L129.19,342.22z"
          />
          <path
            d="M142.02,347.36c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V347.36z"
          />
          <path
            d="M148.18,347.36c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.04-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.98c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V347.36
      z M141.7,339.85l1.25-1.25l1.26,1.26l-1.25,1.25L141.7,339.85z M144.5,339.85l1.25-1.25l1.26,1.26l-1.25,1.25L144.5,339.85z"
          />
          <path
            d="M155.14,345.28c0.03-0.17,0.05-0.37,0.05-0.6c0-0.26-0.01-0.52-0.04-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.51,1.36,1.35,1.36c0.85,0,1.28-0.61,1.28-1.84c0-0.59-0.13-1.32-0.38-2.19l1.47-0.4c0.29,0.91,0.43,1.75,0.42,2.53
      c0,0.02,0,0.03,0,0.05c-0.01,1.3-0.36,2.25-1.05,2.86c-0.43,0.38-1,0.57-1.71,0.57c-1.06,0-1.76-0.4-2.1-1.2
      c-0.58,0.81-1.4,1.21-2.45,1.21c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76
      v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.5c1.17,0,1.85-0.42,2.03-1.26c0.03-0.17,0.05-0.37,0.05-0.6c0-0.25-0.01-0.51-0.03-0.8
      l-0.05-0.52l1.42-0.17l0.14,1.99c0.06,0.91,0.59,1.37,1.58,1.37C154.44,346.54,154.98,346.12,155.14,345.28z"
          />
          <path
            d="M162.55,346.31c0.72,0.15,1.41,0.22,2.07,0.22c2.12,0,3.18-0.52,3.18-1.56c0-1.2-1.19-2.54-3.57-4.04l0.86-1.31
      c2.84,1.69,4.25,3.46,4.25,5.32c0,2.1-1.54,3.15-4.61,3.15c-0.84,0-1.57-0.07-2.18-0.21V346.31z"
          />
          <path
            d="M175.77,343.55l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.12,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L175.77,343.55z"
          />
          <path
            d="M183.21,342.45c0.75,0.81,1.11,1.7,1.09,2.66c-0.03,2-1.73,3.01-5.09,3.01h-1.23c-0.33,0-0.5-0.25-0.5-0.76v-0.16
      c0-0.44,0.17-0.66,0.5-0.66h1.22c2.37,0,3.55-0.55,3.56-1.64c0-0.56-0.3-1.12-0.89-1.68c-0.88-0.82-1.66-1.5-2.35-2.04
      c-0.65-0.51-0.98-1.05-0.98-1.61c0-0.74,0.4-1.27,1.2-1.57l5.96-2.26v1.56l-5.77,2.15C181.42,340.7,182.52,341.7,183.21,342.45z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M823.2,852.57c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24L828,845c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.99-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C819.46,851.5,820.71,852.58,823.2,852.57z M821.95,844.26l1.25-1.25l1.26,1.26l-1.25,1.25
      L821.95,844.26z"
          />
          <path
            d="M834.78,849.41c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.87,2.17h0.15c0.11,0,0.17,0.22,0.17,0.66V849.41z"
          />
          <path
            d="M840.94,849.41c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.03-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.99c0.08,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V849.41
      z M834.46,841.9l1.25-1.25l1.26,1.26l-1.25,1.25L834.46,841.9z M837.26,841.9l1.25-1.25l1.26,1.26l-1.25,1.25L837.26,841.9z"
          />
          <path
            d="M849.43,847.22c0.06,0.91,0.52,1.36,1.37,1.36c0.86,0,1.29-0.57,1.28-1.71c0-0.45-0.01-0.83-0.04-1.12l-0.04-0.52
      l1.42-0.17l0.14,1.63c0.11,1.27,0.64,1.9,1.59,1.9h0.15c0.11,0,0.17,0.22,0.17,0.66v0.16c0,0.5-0.06,0.76-0.17,0.76h-0.14
      c-1.15,0-1.86-0.41-2.14-1.23c-0.41,0.82-1.13,1.23-2.17,1.23s-1.74-0.4-2.13-1.21c-0.58,0.81-1.4,1.21-2.45,1.21
      c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66
      h0.5c1.18,0,1.86-0.42,2.04-1.26c0.03-0.14,0.04-0.34,0.04-0.6c0-0.25-0.01-0.51-0.03-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.59,1.37,1.58,1.37c0.92,0,1.47-0.42,1.63-1.26c0.03-0.14,0.04-0.34,0.04-0.6c0-0.26-0.01-0.52-0.03-0.8l-0.05-0.52
      l1.42-0.17L849.43,847.22z"
          />
          <path
            d="M855.15,850.17c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.52c1.89,0,4.23-0.72,7.01-2.16l0.64-0.33
      c-0.15-0.04-0.77-0.28-1.86-0.72c-1.12-0.45-1.89-0.68-2.29-0.68c-0.65,0-1.18,0.27-1.6,0.81l-0.24,0.31l-1.32-0.65l0.14-0.24
      c0.72-1.19,1.73-1.78,3.03-1.79c0.73,0,1.6,0.25,2.61,0.74c1.79,0.87,3.17,1.33,4.15,1.37l-0.02,1.5
      c-0.66,0.06-1.87,0.55-3.64,1.49c-2.46,1.29-4.7,1.94-6.71,1.94H855.15z M858.55,852.75l1.22-1.22l1.22,1.21l-1.23,1.23
      L858.55,852.75z M859.92,855.06l1.23-1.22l1.22,1.22l-1.23,1.22L859.92,855.06z M861.34,852.75l1.23-1.22l1.22,1.21l-1.23,1.23
      L861.34,852.75z"
          />
          <path
            d="M873.56,848.59h0.88c0.11,0,0.17,0.24,0.17,0.73v0.09c0,0.5-0.06,0.76-0.17,0.76l-0.96-0.01c-0.43,2.47-2.36,3.88-5.8,4.22
      l-0.36-1.47c2.72-0.3,4.3-1.21,4.75-2.74h-1.25c-2.1,0-3.15-0.85-3.15-2.56c0-0.69,0.15-1.35,0.45-1.97
      c0.54-1.13,1.35-1.69,2.44-1.69C872.29,843.95,873.29,845.5,873.56,848.59z M872.12,848.59c-0.13-2-0.69-3.01-1.67-3.02
      c-0.54-0.01-0.93,0.34-1.18,1.03c-0.1,0.3-0.16,0.6-0.16,0.88c0,0.74,0.54,1.11,1.61,1.11H872.12z"
          />
          <path
            d="M874.75,850.17h-0.43c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.45c1.52,0,2.29-0.59,2.29-1.78l0.04-9
      h1.49v9c0,1.19,0.62,1.78,1.86,1.78h0.15c0.14,0,0.21,0.22,0.21,0.66v0.16c0,0.5-0.07,0.76-0.21,0.76h-0.13
      c-1.23,0-2.14-0.41-2.72-1.22C877.19,849.76,876.19,850.17,874.75,850.17z"
          />
          <path
            d="M881.13,850.17h-0.65c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.65c0.92,0,1.54-0.09,1.87-0.28
      c0.49-0.29,0.73-0.88,0.73-1.8c0-0.68-0.11-1.44-0.32-2.28l1.4-0.35c0.28,0.89,0.42,1.76,0.42,2.6c0,1.4-0.4,2.41-1.2,3.02
      C883.45,849.95,882.48,850.17,881.13,850.17z M881.59,852.89l1.25-1.25l1.26,1.26l-1.25,1.25L881.59,852.89z"
          />
          <path
            d="M895.01,850.18c-2.09,0-3.14-0.86-3.14-2.58c0-0.69,0.15-1.35,0.45-1.97c0.54-1.13,1.35-1.69,2.44-1.69
      c1.17,0,2,0.66,2.51,1.97c0.35,0.91,0.52,1.92,0.51,3.05c-0.02,3.21-1.99,5.01-5.91,5.41l-0.36-1.46c2.7-0.28,4.29-1.23,4.77-2.86
      C895.6,850.14,895.18,850.18,895.01,850.18z M896.33,848.43c-0.13-1.91-0.68-2.86-1.67-2.86c-0.55,0-0.94,0.34-1.18,1.03
      c-0.1,0.31-0.15,0.6-0.15,0.88c0,0.79,0.56,1.18,1.69,1.18C895.44,848.65,895.87,848.57,896.33,848.43z"
          />
          <path
            d="M909.6,852.57c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.99-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C905.86,851.5,907.11,852.58,909.6,852.57z M908.35,844.26l1.25-1.25l1.26,1.26l-1.25,1.25
      L908.35,844.26z"
          />
          <path
            d="M921.19,849.41c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V849.41z"
          />
          <path
            d="M927.35,849.41c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.04-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.99c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V849.41
      z M920.87,841.9l1.25-1.25l1.26,1.26l-1.25,1.25L920.87,841.9z M923.66,841.9l1.25-1.25l1.26,1.26l-1.25,1.25L923.66,841.9z"
          />
          <path
            d="M935.83,847.22c0.06,0.91,0.52,1.36,1.37,1.36c0.86,0,1.29-0.57,1.28-1.71c0-0.45-0.01-0.83-0.04-1.12l-0.04-0.52
      l1.42-0.17l0.14,1.63c0.11,1.27,0.64,1.9,1.59,1.9h0.15c0.12,0,0.17,0.22,0.17,0.66v0.16c0,0.5-0.06,0.76-0.17,0.76h-0.14
      c-1.15,0-1.86-0.41-2.14-1.23c-0.41,0.82-1.13,1.23-2.17,1.23s-1.74-0.4-2.13-1.21c-0.58,0.81-1.4,1.21-2.45,1.21
      c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66
      h0.5c1.18,0,1.86-0.42,2.04-1.26c0.03-0.14,0.04-0.34,0.04-0.6c0-0.25-0.01-0.51-0.03-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.59,1.37,1.58,1.37c0.92,0,1.47-0.42,1.63-1.26c0.03-0.14,0.04-0.34,0.04-0.6c0-0.26-0.01-0.52-0.04-0.8l-0.05-0.52
      l1.42-0.17L935.83,847.22z"
          />
          <path
            d="M948.01,849.41c0,0.5-0.06,0.76-0.17,0.76h-0.09c-1.13,0-1.92-0.4-2.35-1.21c-0.57,0.81-1.56,1.21-2.97,1.21h-0.89
      c-0.33,0-0.49-0.25-0.49-0.76v-0.16c0-0.44,0.16-0.66,0.49-0.66h0.85c1.32,0,2.06-0.38,2.2-1.13c0.04-0.2,0.05-0.44,0.05-0.71
      c0-0.29-0.01-0.56-0.03-0.82l-0.04-0.7l1.41-0.17l0.14,1.99c0.07,1.03,0.62,1.55,1.65,1.55h0.07c0.12,0,0.17,0.25,0.17,0.74V849.41
      z M941.42,852.89l1.25-1.25l1.26,1.26l-1.25,1.25L941.42,852.89z M944.22,852.89l1.25-1.25l1.26,1.26l-1.25,1.25L944.22,852.89z"
          />
          <path
            d="M954.97,847.32c0.03-0.17,0.05-0.37,0.05-0.6c0-0.26-0.01-0.52-0.04-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.51,1.36,1.35,1.36c0.85,0,1.28-0.61,1.28-1.84c0-0.59-0.13-1.32-0.38-2.19l1.47-0.4c0.29,0.91,0.43,1.75,0.42,2.53
      c0,0.02,0,0.03,0,0.05c-0.01,1.3-0.36,2.25-1.05,2.86c-0.43,0.38-1,0.57-1.71,0.57c-1.06,0-1.76-0.4-2.1-1.2
      c-0.58,0.81-1.4,1.21-2.45,1.21c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76
      v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.5c1.17,0,1.85-0.42,2.03-1.26c0.03-0.17,0.05-0.37,0.05-0.6c0-0.25-0.01-0.51-0.03-0.8
      l-0.05-0.52l1.42-0.17l0.14,1.99c0.06,0.91,0.59,1.37,1.58,1.37C954.27,848.59,954.81,848.17,954.97,847.32z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M736.77,346.26c0,2.08,1.35,3.12,4.07,3.14c1.02,0,1.93-0.19,2.73-0.56c0.42-0.19,0.78-0.45,1.1-0.77
      c0.31-0.33,0.47-0.7,0.47-1.11c0-0.33-0.22-0.49-0.67-0.49l-0.98-0.01c-1.43-0.01-2.14-0.58-2.14-1.71c0-1.08,0.34-2,1.03-2.75
      c0.89-0.97,2.14-1.45,3.75-1.45h0.18v1.66h-0.19c-0.92,0-1.68,0.21-2.28,0.63c-0.61,0.43-0.92,0.96-0.94,1.58
      c0,0.17,0.05,0.29,0.14,0.37c0.1,0.08,0.25,0.12,0.46,0.12h1.02c1.36-0.01,2.04,0.56,2.04,1.71c0,1.66-0.82,2.87-2.47,3.63
      c-0.97,0.44-2.07,0.66-3.3,0.66c-3.68,0-5.53-1.54-5.53-4.61c0-1.23,0.4-2.75,1.19-4.55l1.37,0.56
      C737.12,343.9,736.77,345.22,736.77,346.26z"
          />
          <path
            d="M754.33,345.04h0.88c0.11,0,0.17,0.24,0.17,0.73v0.09c0,0.5-0.06,0.76-0.17,0.76l-0.96-0.01c-0.43,2.47-2.36,3.88-5.8,4.22
      l-0.36-1.47c2.72-0.3,4.3-1.21,4.75-2.74h-1.25c-2.1,0-3.14-0.85-3.14-2.56c0-0.69,0.15-1.35,0.45-1.97
      c0.54-1.13,1.35-1.69,2.44-1.69C753.07,340.39,754.07,341.94,754.33,345.04z M752.9,345.03c-0.13-2-0.69-3.01-1.67-3.02
      c-0.54-0.01-0.93,0.34-1.18,1.03c-0.1,0.3-0.16,0.6-0.16,0.88c0,0.74,0.54,1.11,1.61,1.11H752.9z"
          />
          <path
            d="M758.14,345.36c-0.61,0.83-1.58,1.25-2.9,1.25h-0.15c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.51-0.66h0.14
      c1.28,0,1.99-0.38,2.12-1.13c0.06-0.35,0.07-0.87,0.03-1.53l-0.04-0.7l1.41-0.17l0.15,1.99c0.06,0.76,0.29,1.19,0.69,1.29
      c2.04-3.46,4.01-5.19,5.89-5.18c1.21,0,2.13,0.45,2.76,1.36c0.38,0.54,0.56,1.14,0.56,1.8c0,0.31-0.04,0.64-0.12,0.99
      c-0.44,1.91-2.5,2.87-6.17,2.87h-0.44C759.95,346.61,758.64,346.19,758.14,345.36z M761.23,345.03h1.32c1.59,0,2.73-0.15,3.42-0.46
      c0.83-0.37,1.25-0.94,1.25-1.71c0-0.37-0.1-0.68-0.3-0.94c-0.34-0.44-0.81-0.66-1.43-0.67
      C764.26,341.25,762.84,342.51,761.23,345.03z M764.05,336.44l1.25-1.25l1.26,1.26l-1.25,1.25L764.05,336.44z"
          />
          <path
            d="M775.22,342.04c0.48,1.09,0.72,2.15,0.72,3.16c0,3.32-2,5.2-6.01,5.62l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.88-0.22-1.79-0.67-2.75L775.22,342.04z"
          />
          <path
            d="M787.73,349.02c2.73-0.01,4.09-1.28,4.08-3.81c0-1.1-0.26-2.18-0.77-3.24l1.49-0.52c0.56,1.4,0.84,2.66,0.84,3.77
      c-0.01,1.07-0.2,1.98-0.58,2.76c-0.85,1.71-2.56,2.56-5.13,2.55c-3.45,0-5.18-1.58-5.19-4.75c0-1.22,0.29-2.53,0.86-3.92l1.37,0.56
      c-0.48,1.21-0.72,2.34-0.71,3.38C783.99,347.95,785.24,349.02,787.73,349.02z M786.48,340.71l1.25-1.25l1.26,1.26l-1.25,1.25
      L786.48,340.71z"
          />
          <path
            d="M799.32,345.85c0.01,0.5-0.05,0.76-0.17,0.76h-0.18c-2.22,0-3.33-1.24-3.33-3.73v-8.63h1.5v8.61
      c0,1.44,0.62,2.17,1.86,2.17h0.16c0.11,0,0.17,0.22,0.17,0.66V345.85z"
          />
          <path
            d="M806.28,343.77c0.03-0.17,0.05-0.37,0.05-0.6c0-0.26-0.01-0.52-0.04-0.8l-0.05-0.52l1.42-0.17l0.14,1.99
      c0.06,0.91,0.51,1.36,1.35,1.36c0.85,0,1.28-0.61,1.28-1.84c0-0.59-0.13-1.32-0.38-2.19l1.47-0.4c0.29,0.91,0.43,1.75,0.42,2.53
      c0,0.02,0,0.03,0,0.05c-0.01,1.3-0.36,2.25-1.05,2.86c-0.43,0.38-1,0.57-1.71,0.57c-1.06,0-1.76-0.4-2.1-1.2
      c-0.58,0.81-1.4,1.21-2.45,1.21c-1.23-0.01-2.01-0.41-2.35-1.21c-0.46,0.81-1.38,1.21-2.78,1.21h-0.48c-0.33,0-0.5-0.25-0.5-0.76
      v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.5c1.17,0,1.85-0.42,2.03-1.26c0.03-0.17,0.05-0.37,0.05-0.6c0-0.25-0.01-0.51-0.03-0.8
      l-0.05-0.52l1.42-0.17l0.14,1.99c0.06,0.91,0.59,1.37,1.58,1.37C805.57,345.03,806.11,344.61,806.28,343.77z"
          />
          <path d="M814.2,334.25h1.49v12.35h-1.49V334.25z" />
          <path
            d="M822.54,342.04l0.49,1.66c0.26,0.89,0.8,1.33,1.63,1.33h0.24c0.12,0,0.17,0.21,0.17,0.62v0.21c0,0.5-0.06,0.76-0.17,0.76
      h-0.15c-0.81,0-1.33-0.15-1.56-0.46c-0.33,2.72-2.31,4.28-5.94,4.67l-0.36-1.46c3.25-0.33,4.87-1.68,4.86-4.06
      c0-0.86-0.23-1.77-0.68-2.74L822.54,342.04z"
          />
          <path
            d="M824.76,346.61c-0.33,0-0.5-0.25-0.5-0.76v-0.16c0-0.44,0.17-0.66,0.5-0.66h0.52c1.89,0,4.23-0.72,7.01-2.16l0.64-0.33
      c-0.15-0.04-0.77-0.28-1.86-0.72c-1.12-0.45-1.89-0.68-2.29-0.68c-0.65,0-1.18,0.27-1.6,0.81l-0.24,0.31l-1.32-0.65l0.14-0.24
      c0.72-1.19,1.73-1.78,3.03-1.79c0.73,0,1.6,0.25,2.61,0.74c1.79,0.87,3.17,1.33,4.15,1.37l-0.02,1.5
      c-0.66,0.06-1.87,0.55-3.64,1.49c-2.46,1.29-4.69,1.94-6.71,1.94H824.76z M828.21,336.43l1.25-1.25l1.26,1.26l-1.25,1.25
      L828.21,336.43z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M345.65,639.29c-3.09,0-4.63-0.95-4.63-2.85c0-0.53,0.11-1.03,0.32-1.51l0.92,0.4c-0.13,0.32-0.19,0.63-0.19,0.93
      c0,1.29,1.16,1.94,3.47,1.94c1.96,0,3.19-0.19,3.7-0.56c0.25-0.18,0.38-0.51,0.38-0.97c0-0.35-0.07-0.83-0.21-1.44l0.96-0.24
      c0.2,0.59,0.29,1.12,0.29,1.59c0,0.93-0.27,1.58-0.81,1.96c-0.71,0.49-2.1,0.74-4.18,0.74H345.65z M345.07,641.14l0.85-0.85
      l0.86,0.86l-0.85,0.85L345.07,641.14z"
          />
          <path
            d="M357.28,639.3c-1.43,0-2.14-0.59-2.14-1.76c0-0.47,0.1-0.92,0.3-1.34c0.37-0.77,0.92-1.15,1.66-1.15
      c0.8,0,1.37,0.45,1.71,1.34c0.24,0.62,0.36,1.31,0.35,2.08c-0.02,2.19-1.36,3.42-4.03,3.69l-0.25-1c1.84-0.19,2.93-0.84,3.25-1.95
      C357.68,639.27,357.39,639.3,357.28,639.3z M358.17,638.1c-0.09-1.3-0.46-1.95-1.14-1.95c-0.38,0-0.64,0.23-0.8,0.7
      c-0.07,0.21-0.11,0.41-0.11,0.6c0,0.54,0.38,0.81,1.15,0.8C357.57,638.25,357.86,638.2,358.17,638.1z"
          />
          <path
            d="M371.99,635.42c0.51,0.55,0.76,1.16,0.75,1.82c-0.03,1.37-1.22,2.05-3.59,2.05h-1.06c-2.98,0-4.48-0.95-4.48-2.85
      c0-0.53,0.11-1.03,0.32-1.51l0.92,0.4c-0.13,0.33-0.19,0.65-0.19,0.96c0.01,1.28,1.15,1.92,3.43,1.92h1.05
      c1.7,0,2.55-0.37,2.54-1.12c0-0.38-0.2-0.76-0.6-1.14c-0.6-0.56-1.14-1.02-1.61-1.39c-0.45-0.35-0.67-0.71-0.67-1.1
      c0-0.5,0.28-0.86,0.83-1.07l4.06-1.54v1.06l-3.94,1.46C370.79,634.25,371.53,634.93,371.99,635.42z"
          />
        </g>
        <g style={{ fill: textColor }}>
          <path
            d="M339.35,564.91c-3.09,0-4.63-0.95-4.63-2.85c0-0.53,0.11-1.03,0.32-1.51l0.92,0.4c-0.13,0.32-0.19,0.63-0.19,0.93
      c0,1.29,1.16,1.94,3.47,1.94c1.96,0,3.19-0.19,3.7-0.56c0.25-0.18,0.38-0.51,0.38-0.97c0-0.35-0.07-0.83-0.21-1.44l0.96-0.24
      c0.2,0.59,0.29,1.12,0.29,1.59c0,0.93-0.27,1.58-0.81,1.96c-0.71,0.49-2.1,0.74-4.18,0.74H339.35z M338.77,566.77l0.85-0.85
      l0.86,0.86l-0.85,0.85L338.77,566.77z"
          />
          <path
            d="M350.98,564.92c-1.43,0-2.14-0.59-2.14-1.76c0-0.47,0.1-0.92,0.3-1.34c0.37-0.77,0.92-1.15,1.66-1.15
      c0.8,0,1.37,0.45,1.71,1.34c0.24,0.62,0.36,1.31,0.35,2.08c-0.02,2.19-1.36,3.42-4.03,3.69l-0.25-1c1.84-0.19,2.93-0.84,3.25-1.95
      C351.38,564.89,351.09,564.92,350.98,564.92z M351.88,563.73c-0.09-1.3-0.46-1.95-1.14-1.95c-0.38,0-0.64,0.23-0.8,0.7
      c-0.07,0.21-0.11,0.41-0.11,0.6c0,0.54,0.38,0.81,1.15,0.8C351.27,563.88,351.57,563.83,351.88,563.73z"
          />
          <path
            d="M357.46,565.76c0-2.28,1.4-3.73,4.2-4.35l0.06-0.01c-0.1-0.04-0.32-0.13-0.67-0.26c-0.76-0.31-1.28-0.46-1.56-0.46
      c-0.44,0-0.8,0.18-1.09,0.55l-0.16,0.21l-0.9-0.45l0.09-0.16c0.49-0.81,1.18-1.21,2.07-1.22h0.01c0.49,0,1.08,0.17,1.78,0.5
      c1.22,0.59,2.16,0.9,2.83,0.93l-0.08,1.02c-0.69,0.04-1.26,0.12-1.71,0.22c-2.57,0.6-3.86,1.73-3.86,3.39
      c0,1.44,1.04,2.16,3.11,2.16c0.85,0,1.66-0.19,2.44-0.56l0.21,1.05c-0.78,0.38-1.69,0.57-2.74,0.57c-1.51,0-2.6-0.36-3.27-1.09
      C357.72,567.25,357.46,566.57,357.46,565.76z M360.59,565.29l0.85-0.85l0.86,0.86l-0.85,0.85L360.59,565.29z"
          />
        </g>
      </svg>
      <Tooltip
        id="iran-map-tooltip"
        variant="light"
        float
        style={{
          padding: '0',
          margin: '0',
          borderRadius: '1rem',
          border: 'none',
          background: gray,
          boxShadow: boxShadow1,
        }}
      >
        <Container>
          <ContainerHeader>{provinceName}</ContainerHeader>
          <ContentContainer>
            <div>{tooltipTitle ? `${tooltipTitle}` : ''}</div>
            <MainContent>
              {provinceName &&
                Object.entries(
                  data?.[
                    //@ts-expect-error jsx error
                    provinces.find(
                      (item: any) => item.provinceFaName === provinceName
                    )?.provinceName
                  ] ?? {}
                ).map(([key, value]) => {
                  return (
                    <div
                      key={`${provinceName}-${key}`}
                      className="flex justify-between items-center gap-2"
                    >
                      <div>{key}</div>
                      <div className="font-bold">{value as string}</div>
                    </div>
                  );
                })}
            </MainContent>
          </ContentContainer>
        </Container>
      </Tooltip>
    </>
  );
};

export default IranMapWrapper;
